/* tslint:disable */
/* eslint-disable */
/**
 * SRATool
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface CommandsCreateAnalysisRequest
 */
export interface CommandsCreateAnalysisRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAnalysisRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAnalysisRequest
     */
    'name': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof CommandsCreateAnalysisRequest
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CommandsCreateAnalysisRequest
     */
    'selectedBAITableIDs': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateAnalysisRequest
     */
    'useProjectData': boolean;
}


/**
 * 
 * @export
 * @interface CommandsCreateAnalysisResponse
 */
export interface CommandsCreateAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAnalysisResponse
     */
    'analysisID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateAnalysisResponse
     */
    'canApplyMeritVariables': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateAnalysisResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateAnalysisResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateExecutiveSummarySettingsRequest
 */
export interface CommandsCreateExecutiveSummarySettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'hiringAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'competitivePromotionsAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'promoTermsTransfersAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'laborforceAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'totalSelectionsAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'dataObservations1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'dataObservations2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'dataObservations3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'dataObservations4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'hiringAnalysisStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'competitivePromotionStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'promoTermsTransfersStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'laborforceStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateExecutiveSummarySettingsRequest
     */
    'totalSelectionsStrataFieldGUID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateFavoredOutcomeSelectionsRequest
 */
export interface CommandsCreateFavoredOutcomeSelectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateFavoredOutcomeSelectionsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateFavoredOutcomeSelectionsRequest
     */
    'analysisFieldGUID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsCreateFavoredOutcomeSelectionsRequest
     */
    'selectedFavoredOutcomeValues': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsCreateFavoredOutcomeSelectionsResponse
 */
export interface CommandsCreateFavoredOutcomeSelectionsResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateFavoredOutcomeSelectionsResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateFavoredOutcomeSelectionsResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateGroupSelectionsRequest
 */
export interface CommandsCreateGroupSelectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateGroupSelectionsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsComparisonType}
     * @memberof CommandsCreateGroupSelectionsRequest
     */
    'selectedComparisonTypeID': EnumerationsComparisonType;
    /**
     * 
     * @type {Array<CommandsSelectedGroupField>}
     * @memberof CommandsCreateGroupSelectionsRequest
     */
    'selectedGroupFields': Array<CommandsSelectedGroupField>;
}


/**
 * 
 * @export
 * @interface CommandsCreateMeritVariablesRequest
 */
export interface CommandsCreateMeritVariablesRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'fieldGUID1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'fieldGUID2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'fieldGUID3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'fieldGUID4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateMeritVariablesRequest
     */
    'fieldGUID5'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsCreateProjectRequest
 */
export interface CommandsCreateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateProjectRequest
     */
    'attorneyClientPrivilege': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'transactionStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'transactionEndDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'snapshotDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'acpNotice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'displayNameForDepartment': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'displayNameForPlanCode': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectRequest
     */
    'displayNameForJobGroup': string;
}
/**
 * 
 * @export
 * @interface CommandsCreateProjectResponse
 */
export interface CommandsCreateProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectResponse
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProjectResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateProjectResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateProportionalGroupSelectionsRequest
 */
export interface CommandsCreateProportionalGroupSelectionsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalGroupSelectionsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsComparisonType}
     * @memberof CommandsCreateProportionalGroupSelectionsRequest
     */
    'comparisonTypeID': EnumerationsComparisonType;
    /**
     * 
     * @type {Array<EnumerationsGroupOptions>}
     * @memberof CommandsCreateProportionalGroupSelectionsRequest
     */
    'groupOptionIDs': Array<EnumerationsGroupOptions>;
    /**
     * 
     * @type {Array<TransferObjectsProjectFieldsDTO>}
     * @memberof CommandsCreateProportionalGroupSelectionsRequest
     */
    'projectFields': Array<TransferObjectsProjectFieldsDTO>;
}


/**
 * 
 * @export
 * @interface CommandsCreateProportionalMeritVariablesRequest
 */
export interface CommandsCreateProportionalMeritVariablesRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'fieldGUID1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'fieldGUID2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'fieldGUID3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'fieldGUID4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'fieldGUID5'?: string | null;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'applyToAnalyses1': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'applyToAnalyses2': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'applyToAnalyses3': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'applyToAnalyses4': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof CommandsCreateProportionalMeritVariablesRequest
     */
    'applyToAnalyses5': Array<EnumerationsProportionalAnalyses>;
}
/**
 * 
 * @export
 * @interface CommandsCreateProportionalStrataRequest
 */
export interface CommandsCreateProportionalStrataRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'strataField1': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'strataField2': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'strataField3': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'strataField4': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateProportionalStrataRequest
     */
    'strataField5': TransferObjectsStrataFieldDTO;
}
/**
 * 
 * @export
 * @interface CommandsCreateProportionalStrataResponse
 */
export interface CommandsCreateProportionalStrataResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalStrataResponse
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateProportionalStrataResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateProportionalStrataResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsCreateStrataRequest
 */
export interface CommandsCreateStrataRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateStrataRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateStrataRequest
     */
    'strataField1': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateStrataRequest
     */
    'strataField2': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateStrataRequest
     */
    'strataField3': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateStrataRequest
     */
    'strataField4': TransferObjectsStrataFieldDTO;
    /**
     * 
     * @type {TransferObjectsStrataFieldDTO}
     * @memberof CommandsCreateStrataRequest
     */
    'strataField5': TransferObjectsStrataFieldDTO;
}
/**
 * 
 * @export
 * @interface CommandsCreateStrataResponse
 */
export interface CommandsCreateStrataResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateStrataResponse
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsCreateStrataResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsCreateStrataResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsDeleteAnalysisRequest
 */
export interface CommandsDeleteAnalysisRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsDeleteAnalysisRequest
     */
    'analysisID': string;
}
/**
 * 
 * @export
 * @interface CommandsDeleteAnalysisResponse
 */
export interface CommandsDeleteAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsDeleteAnalysisResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsDeleteAnalysisResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsDeleteProjectRequest
 */
export interface CommandsDeleteProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsDeleteProjectRequest
     */
    'projectID': string;
}
/**
 * 
 * @export
 * @interface CommandsDeleteProjectResponse
 */
export interface CommandsDeleteProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsDeleteProjectResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsDeleteProjectResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsGenerateExecutiveSummaryRequest
 */
export interface CommandsGenerateExecutiveSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsGenerateExecutiveSummaryRequest
     */
    'projectID': string;
    /**
     * 
     * @type {Array<CommandsStoreScreenshotsRequest>}
     * @memberof CommandsGenerateExecutiveSummaryRequest
     */
    'analysesToGenerate': Array<CommandsStoreScreenshotsRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsGenerateExecutiveSummaryRequest
     */
    'regenerate': boolean;
}
/**
 * 
 * @export
 * @interface CommandsGrantUserAccessToProjectRequest
 */
export interface CommandsGrantUserAccessToProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsGrantUserAccessToProjectRequest
     */
    'projectID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsGrantUserAccessToProjectRequest
     */
    'userIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsGrantUserAccessToProjectResponse
 */
export interface CommandsGrantUserAccessToProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsGrantUserAccessToProjectResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsGrantUserAccessToProjectResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsImportFromBAISetupRequest
 */
export interface CommandsImportFromBAISetupRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsImportFromBAISetupRequest
     */
    'projectID': string;
    /**
     * 
     * @type {Array<TransferObjectsAvailableBAITablesDTO>}
     * @memberof CommandsImportFromBAISetupRequest
     */
    'tables': Array<TransferObjectsAvailableBAITablesDTO>;
    /**
     * 
     * @type {number}
     * @memberof CommandsImportFromBAISetupRequest
     */
    'selectedBAIPlanID': number;
}
/**
 * 
 * @export
 * @interface CommandsImportSetupResponse
 */
export interface CommandsImportSetupResponse {
    /**
     * 
     * @type {TransferObjectsResponseDTO}
     * @memberof CommandsImportSetupResponse
     */
    'response': TransferObjectsResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof CommandsImportSetupResponse
     */
    'importID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsReImportAvailabilityDataFromBAISetupRequest
 */
export interface CommandsReImportAvailabilityDataFromBAISetupRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsReImportAvailabilityDataFromBAISetupRequest
     */
    'projectID': string;
}
/**
 * 
 * @export
 * @interface CommandsReImportAvailabilityDataFromBAISetupResponse
 */
export interface CommandsReImportAvailabilityDataFromBAISetupResponse {
    /**
     * 
     * @type {TransferObjectsResponseDTO}
     * @memberof CommandsReImportAvailabilityDataFromBAISetupResponse
     */
    'response': TransferObjectsResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof CommandsReImportAvailabilityDataFromBAISetupResponse
     */
    'importID'?: string | null;
}
/**
 * 
 * @export
 * @interface CommandsRemoveUserAccessFromProjectRequest
 */
export interface CommandsRemoveUserAccessFromProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsRemoveUserAccessFromProjectRequest
     */
    'projectID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsRemoveUserAccessFromProjectRequest
     */
    'userIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsRemoveUserAccessFromProjectResponse
 */
export interface CommandsRemoveUserAccessFromProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsRemoveUserAccessFromProjectResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsRemoveUserAccessFromProjectResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsSelectedGroupField
 */
export interface CommandsSelectedGroupField {
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectedGroupField
     */
    'selectedFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectedGroupField
     */
    'excludedReferenceGroupValue': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectedGroupField
     */
    'excludedFocalGroupValue': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsSelectedGroupField
     */
    'referenceGroupValue': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSelectedGroupField
     */
    'comparisonGroupValues': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsSendProjectSharedEmailsRequest
 */
export interface CommandsSendProjectSharedEmailsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsSendProjectSharedEmailsRequest
     */
    'projectID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CommandsSendProjectSharedEmailsRequest
     */
    'userIDs': Array<string>;
}
/**
 * 
 * @export
 * @interface CommandsSendProjectSharedEmailsResponse
 */
export interface CommandsSendProjectSharedEmailsResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsSendProjectSharedEmailsResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsSendProjectSharedEmailsResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsStoreScreenshotsRequest
 */
export interface CommandsStoreScreenshotsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsStoreScreenshotsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsStoreScreenshotsRequest
     */
    'clientFilePath': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CommandsStoreScreenshotsRequest
     */
    'base64Images'?: { [key: string]: string; } | null;
}
/**
 * 
 * @export
 * @interface CommandsUpdateAnalysisRequest
 */
export interface CommandsUpdateAnalysisRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'name': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {Array<number>}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'selectedBAITableIDs': Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateAnalysisRequest
     */
    'useProjectData': boolean;
}


/**
 * 
 * @export
 * @interface CommandsUpdateAnalysisResponse
 */
export interface CommandsUpdateAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateAnalysisResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateAnalysisResponse
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateAnalysisResponse
     */
    'canApplyMeritVariables': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateProjectRequest
 */
export interface CommandsUpdateProjectRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectRequest
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectRequest
     */
    'attorneyClientPrivilege': boolean;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'transactionStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'transactionEndDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'snapshotDate': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'acpNotice'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'displayNameForDepartment': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'displayNameForPlanCode': string;
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectRequest
     */
    'displayNameForJobGroup': string;
}
/**
 * 
 * @export
 * @interface CommandsUpdateProjectResponse
 */
export interface CommandsUpdateProjectResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateProjectSharingRequest
 */
export interface CommandsUpdateProjectSharingRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectSharingRequest
     */
    'projectID': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectSharingRequest
     */
    'shareWithClients': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateProjectSharingResponse
 */
export interface CommandsUpdateProjectSharingResponse {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateProjectSharingResponse
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof CommandsUpdateProjectSharingResponse
     */
    'success': boolean;
}
/**
 * 
 * @export
 * @interface CommandsUpdateReportSettingsRequest
 */
export interface CommandsUpdateReportSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateReportSettingsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsAnalysisCategory}
     * @memberof CommandsUpdateReportSettingsRequest
     */
    'analysisCategoryID': EnumerationsAnalysisCategory;
    /**
     * 
     * @type {EnumerationsSplitResultsOptions}
     * @memberof CommandsUpdateReportSettingsRequest
     */
    'splitResultsOptionID': EnumerationsSplitResultsOptions;
}


/**
 * 
 * @export
 * @interface CommandsUpdateSummariesExportSettingsRequest
 */
export interface CommandsUpdateSummariesExportSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof CommandsUpdateSummariesExportSettingsRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof CommandsUpdateSummariesExportSettingsRequest
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {Array<EnumerationsSummaryExportSheet>}
     * @memberof CommandsUpdateSummariesExportSettingsRequest
     */
    'summaryExportSheets': Array<EnumerationsSummaryExportSheet>;
}


/**
 * 
 * @export
 * @interface DataVizDispCodeGroupChartData
 */
export interface DataVizDispCodeGroupChartData {
    /**
     * 
     * @type {string}
     * @memberof DataVizDispCodeGroupChartData
     */
    'dispCodeDescription': string;
    /**
     * 
     * @type {Array<DataVizTileGroupCountsDTO>}
     * @memberof DataVizDispCodeGroupChartData
     */
    'groupData': Array<DataVizTileGroupCountsDTO>;
}
/**
 * 
 * @export
 * @interface DataVizGetDefaultSignificantResultsSummaryDTO
 */
export interface DataVizGetDefaultSignificantResultsSummaryDTO {
    /**
     * 
     * @type {Array<DataVizMeritVariableDTO>}
     * @memberof DataVizGetDefaultSignificantResultsSummaryDTO
     */
    'meritVariables': Array<DataVizMeritVariableDTO>;
    /**
     * 
     * @type {Array<TransferObjectsViewByOptions>}
     * @memberof DataVizGetDefaultSignificantResultsSummaryDTO
     */
    'viewByOptions': Array<TransferObjectsViewByOptions>;
    /**
     * 
     * @type {Array<DataVizGetSignificantResultsSummaryDTO>}
     * @memberof DataVizGetDefaultSignificantResultsSummaryDTO
     */
    'significantResultsSummaryDataResponse': Array<DataVizGetSignificantResultsSummaryDTO>;
}
/**
 * 
 * @export
 * @interface DataVizGetDefaultStatisticalValueSummaryDTO
 */
export interface DataVizGetDefaultStatisticalValueSummaryDTO {
    /**
     * 
     * @type {Array<TransferObjectsViewByOptions>}
     * @memberof DataVizGetDefaultStatisticalValueSummaryDTO
     */
    'viewByOptions': Array<TransferObjectsViewByOptions>;
    /**
     * 
     * @type {Array<DataVizGetStatisticalValueSummaryDTO>}
     * @memberof DataVizGetDefaultStatisticalValueSummaryDTO
     */
    'statisticalValuesSummaryDataResponse': Array<DataVizGetStatisticalValueSummaryDTO>;
}
/**
 * 
 * @export
 * @interface DataVizGetSignificantResultsSummaryDTO
 */
export interface DataVizGetSignificantResultsSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizGetSignificantResultsSummaryDTO
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {Array<TransferObjectsSignificantResultsSummaryDTO>}
     * @memberof DataVizGetSignificantResultsSummaryDTO
     */
    'significantResultsSummaryData': Array<TransferObjectsSignificantResultsSummaryDTO>;
}
/**
 * 
 * @export
 * @interface DataVizGetStatisticalValueSummaryDTO
 */
export interface DataVizGetStatisticalValueSummaryDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'totalRecords': number;
    /**
     * 
     * @type {Array<any>}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'statisticalValuesSummaryData': Array<any>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'groupColumnHeaders': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'strataLevel1ColumnHeader': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'strataLevel2ColumnHeader'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'strataLevel3ColumnHeader'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'strataLevel4ColumnHeader'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizGetStatisticalValueSummaryDTO
     */
    'strataLevel5ColumnHeader'?: string | null;
}
/**
 * 
 * @export
 * @interface DataVizMeritVariableDTO
 */
export interface DataVizMeritVariableDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizMeritVariableDTO
     */
    'fieldID': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizMeritVariableDTO
     */
    'fieldNumber': number;
    /**
     * 
     * @type {string}
     * @memberof DataVizMeritVariableDTO
     */
    'displayName': string;
}
/**
 * 
 * @export
 * @interface DataVizOverviewPADTO
 */
export interface DataVizOverviewPADTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'analysisName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof DataVizOverviewPADTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof DataVizOverviewPADTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalSignificant': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableAvailableAverage1': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableAvailableAverage2': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableAvailableAverage3': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableAvailableAverage4': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableAvailableAverage5': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableSelectedAverage1': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableSelectedAverage2': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableSelectedAverage3': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableSelectedAverage4': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableSelectedAverage5': number;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableName1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableName2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableName3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableName4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'meritVariableName5'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalStrataLevel1': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalStrataLevel2': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalStrataLevel3': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalStrataLevel4': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizOverviewPADTO
     */
    'totalStrataLevel5': number;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'strataLevel1Name': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'strataLevel2Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'strataLevel3Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'strataLevel4Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizOverviewPADTO
     */
    'strataLevel5Name'?: string | null;
}


/**
 * 
 * @export
 * @interface DataVizSignificantResultsInBothAreasDTO
 */
export interface DataVizSignificantResultsInBothAreasDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'strataField1Value': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'strataField2Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'strataField3Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'strataField4Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'strataField5Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'group': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'appPoolGap': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'appPoolStatValue': number;
    /**
     * 
     * @type {string}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'workforceGap': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizSignificantResultsInBothAreasDTO
     */
    'workforceStatValue': number;
}
/**
 * 
 * @export
 * @interface DataVizTileChartDataByStrataByGroupFieldValueDTO
 */
export interface DataVizTileChartDataByStrataByGroupFieldValueDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataByStrataByGroupFieldValueDTO
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {Array<DataVizTileGroupCountsDTO>}
     * @memberof DataVizTileChartDataByStrataByGroupFieldValueDTO
     */
    'groupCounts': Array<DataVizTileGroupCountsDTO>;
}
/**
 * 
 * @export
 * @interface DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO
 */
export interface DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {Array<DataVizTileOverUnderGroupCountsDTO>}
     * @memberof DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO
     */
    'groupCounts': Array<DataVizTileOverUnderGroupCountsDTO>;
}
/**
 * 
 * @export
 * @interface DataVizTileChartDataDTO
 */
export interface DataVizTileChartDataDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataDTO
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataDTO
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataDTO
     */
    'chartInsight': string;
    /**
     * 
     * @type {Array<DataVizTileChartDataByStrataByGroupFieldValueDTO>}
     * @memberof DataVizTileChartDataDTO
     */
    'chartDataByStrataByGroupFieldValue': Array<DataVizTileChartDataByStrataByGroupFieldValueDTO>;
}
/**
 * 
 * @export
 * @interface DataVizTileChartDataOverUnderCountDTO
 */
export interface DataVizTileChartDataOverUnderCountDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataOverUnderCountDTO
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataOverUnderCountDTO
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileChartDataOverUnderCountDTO
     */
    'chartInsight': string;
    /**
     * 
     * @type {Array<DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO>}
     * @memberof DataVizTileChartDataOverUnderCountDTO
     */
    'chartDataByStrataByGroupFieldValue': Array<DataVizTileChartDataByStrataByGroupFieldValueOverUnderCountsDTO>;
}
/**
 * 
 * @export
 * @interface DataVizTileGroupCountsDTO
 */
export interface DataVizTileGroupCountsDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileGroupCountsDTO
     */
    'groupFieldValue': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileGroupCountsDTO
     */
    'stack': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileGroupCountsDTO
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileGroupCountsDTO
     */
    'percent': number;
}
/**
 * 
 * @export
 * @interface DataVizTileLaborMarketTileDataDTO
 */
export interface DataVizTileLaborMarketTileDataDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileLaborMarketTileDataDTO
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof DataVizTileLaborMarketTileDataDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileLaborMarketTileDataDTO
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileLaborMarketTileDataDTO
     */
    'strataWithSignificantResults': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileLaborMarketTileDataDTO
     */
    'numberOfUniqueStrata': number;
}


/**
 * 
 * @export
 * @interface DataVizTileOverUnderGroupCountsDTO
 */
export interface DataVizTileOverUnderGroupCountsDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'groupFieldValue': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'stack': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'overCount': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'overPercent': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'underCount': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileOverUnderGroupCountsDTO
     */
    'underPercent': number;
}
/**
 * 
 * @export
 * @interface DataVizTileStrataTileDataDTO
 */
export interface DataVizTileStrataTileDataDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTileStrataTileDataDTO
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileStrataTileDataDTO
     */
    'totalStrataCount': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileStrataTileDataDTO
     */
    'significantStrataCount': number;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileStrataTileDataDTO
     */
    'significantStrataPercentage': number;
}
/**
 * 
 * @export
 * @interface DataVizTileWorkforceRepresentationTileData
 */
export interface DataVizTileWorkforceRepresentationTileData {
    /**
     * 
     * @type {number}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalEmployees': number;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalDistinctStrata1': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalDistinctStrata2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'hireRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'hiredDistinctStrata1'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalHired'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'promotionRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'promotionDistinctStrata1'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalPromoted'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'turnoverRate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'terminatedDistinctStrata1'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DataVizTileWorkforceRepresentationTileData
     */
    'totalTerminated'?: number | null;
}
/**
 * 
 * @export
 * @interface DataVizTop10BiggestGapsDTO
 */
export interface DataVizTop10BiggestGapsDTO {
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'strataField1Value': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'strataField2Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'strataField3Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'strataField4Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'strataField5Value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'planCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'group': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'laborMarketPercent': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'representationPercent': string;
    /**
     * 
     * @type {string}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'gap': string;
    /**
     * 
     * @type {number}
     * @memberof DataVizTop10BiggestGapsDTO
     */
    'selectedCount': number;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsAnalysisCategory = {
    SelectionRateAnalysis: 1,
    ProportionalAnalysis: 2
} as const;

export type EnumerationsAnalysisCategory = typeof EnumerationsAnalysisCategory[keyof typeof EnumerationsAnalysisCategory];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsAnalysisSteps = {
    NotStarted: 1,
    Import: 2,
    RunAnalysisBy: 3,
    SelectionField: 4,
    GroupSelections: 5,
    Summary: 6,
    Complete: 7,
    MeritVariables: 8
} as const;

export type EnumerationsAnalysisSteps = typeof EnumerationsAnalysisSteps[keyof typeof EnumerationsAnalysisSteps];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsAnalysisType = {
    ApplicantsVsHires: 1,
    ApplicantsVsCompetitivePromotions: 2,
    NonCompetitivePromotions: 3,
    TerminationsAll: 4,
    InvoluntaryTerminations: 5,
    VoluntaryTerminations: 6,
    Custom: 7,
    StepAnalysis: 8,
    ApplicantsWorkforcePromotionsTerminations: 9,
    TotalSelections: 10
} as const;

export type EnumerationsAnalysisType = typeof EnumerationsAnalysisType[keyof typeof EnumerationsAnalysisType];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsComparisonType = {
    AllGroupsToAllGroups: 1,
    AllGroupsToGroupWithHighestSelectionAllGroups: 2,
    AllGroupsToGroupWithHighestSelectionHighestGroup2PercentOfPool: 3,
    SpecificGroups: 4
} as const;

export type EnumerationsComparisonType = typeof EnumerationsComparisonType[keyof typeof EnumerationsComparisonType];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsComplianceType = {
    EO11246: 1,
    NonDiscrimination: 2,
    IWD503VETSVEVRAALegacy: 3,
    StateandLocalReporting: 4,
    AttorneyClientPrivilege: 5,
    ProportionalAnalyses: 6,
    IWD503VETSVEVRAA2026: 7
} as const;

export type EnumerationsComplianceType = typeof EnumerationsComplianceType[keyof typeof EnumerationsComplianceType];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsDataVizSortBy = {
    HighestStatValue: 1,
    HighestShortfall: 2,
    MostTransactions: 3
} as const;

export type EnumerationsDataVizSortBy = typeof EnumerationsDataVizSortBy[keyof typeof EnumerationsDataVizSortBy];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsExecutiveSummaryStatus = {
    NotStarted: 1,
    Running: 2,
    Completed: 3,
    Failed: 4
} as const;

export type EnumerationsExecutiveSummaryStatus = typeof EnumerationsExecutiveSummaryStatus[keyof typeof EnumerationsExecutiveSummaryStatus];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsGroupOptions = {
    Race: 1,
    Sex: 2,
    RaceSex: 3
} as const;

export type EnumerationsGroupOptions = typeof EnumerationsGroupOptions[keyof typeof EnumerationsGroupOptions];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsProjectAccessSortColumn = {
    SnapShotDate: 1,
    ProjectName: 2,
    LastRunDate: 3,
    AnalysisCount: 4,
    ProjectIdentifier: 5,
    ShareWithClients: 6
} as const;

export type EnumerationsProjectAccessSortColumn = typeof EnumerationsProjectAccessSortColumn[keyof typeof EnumerationsProjectAccessSortColumn];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsProportionalAnalyses = {
    ApplicantPoolVsLaborMarket: 1,
    WorkforceVsLaborMarket: 2,
    NonCompetitivePromotionsAnalysis: 3,
    AllTerminationsAnalysis: 4,
    VoluntaryTerminationsAnalysis: 5,
    InvoluntaryTerminationsAnalysis: 6,
    ApplicantLaborMarketComposition: 7,
    WorkforceRepresentationReport: 8,
    DetailedWorkforceRepresentationReport: 9,
    CompensationReport: 10,
    WorkforceLaborMarketComposition: 11
} as const;

export type EnumerationsProportionalAnalyses = typeof EnumerationsProportionalAnalyses[keyof typeof EnumerationsProportionalAnalyses];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsReportGroup = {
    CompetitiveMovementsSelectionRateAnalysisReports: 1,
    NonCompetitiveMovementsProportionalAnalysisReports: 2,
    TalentAvailabilityReports: 3,
    WorkforceInsightReports: 4
} as const;

export type EnumerationsReportGroup = typeof EnumerationsReportGroup[keyof typeof EnumerationsReportGroup];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsSignificanceFilter = {
    NotSignificant: 1,
    ApproachSignificance: 2,
    Significant: 3,
    MoreSignificant: 4,
    HighlySignificant: 5
} as const;

export type EnumerationsSignificanceFilter = typeof EnumerationsSignificanceFilter[keyof typeof EnumerationsSignificanceFilter];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsSortDirection = {
    Ascending: 1,
    Descending: 2
} as const;

export type EnumerationsSortDirection = typeof EnumerationsSortDirection[keyof typeof EnumerationsSortDirection];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsSplitResultsOptions = {
    NoSplit: 0,
    SeparateWorkbooks: 1,
    SeparateWorksheets: 2,
    SeparateWorkbooksAndWorksheets: 3
} as const;

export type EnumerationsSplitResultsOptions = typeof EnumerationsSplitResultsOptions[keyof typeof EnumerationsSplitResultsOptions];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsSummaryExportSheet = {
    Gaps: 1,
    SignificantGaps: 2,
    SignificantResultsDrilldown: 3,
    InstancesOfSignificance: 4,
    AnalysisResults: 5
} as const;

export type EnumerationsSummaryExportSheet = typeof EnumerationsSummaryExportSheet[keyof typeof EnumerationsSummaryExportSheet];


/**
 * 
 * @export
 * @enum {number}
 */

export const EnumerationsSummaryGroup = {
    CompetitiveMovementsSelectionRateAnalysisSummaries: 1,
    NonCompetitiveMovementsProportionalAnalysisSummaries: 2,
    TalentAvailabilitySummaries: 3
} as const;

export type EnumerationsSummaryGroup = typeof EnumerationsSummaryGroup[keyof typeof EnumerationsSummaryGroup];


/**
 * 
 * @export
 * @interface ModelsBAIImportTables
 */
export interface ModelsBAIImportTables {
    /**
     * 
     * @type {number}
     * @memberof ModelsBAIImportTables
     */
    'baiImportTableID': number;
    /**
     * 
     * @type {string}
     * @memberof ModelsBAIImportTables
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof ModelsBAIImportTables
     */
    'tableCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModelsBAIImportTables
     */
    'tableName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsBAIImportTables
     */
    'selected': boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelsBAIImportTables
     */
    'actionTypeID': number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsBAIImportTables
     */
    'isUPA': boolean;
    /**
     * 
     * @type {number}
     * @memberof ModelsBAIImportTables
     */
    'jobs': number;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsBAIImportTables
     */
    'positive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModelsBAIImportTables
     */
    'useAggregateAction': boolean;
    /**
     * 
     * @type {string}
     * @memberof ModelsBAIImportTables
     */
    'dataTableName'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesAnalysisWithName
 */
export interface QueriesAnalysisWithName {
    /**
     * 
     * @type {string}
     * @memberof QueriesAnalysisWithName
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesAnalysisWithName
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface QueriesApplicantFlowTileData
 */
export interface QueriesApplicantFlowTileData {
    /**
     * 
     * @type {number}
     * @memberof QueriesApplicantFlowTileData
     */
    'totalApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesApplicantFlowTileData
     */
    'hiredApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesApplicantFlowTileData
     */
    'excludedApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesApplicantFlowTileData
     */
    'totalDispositions': number;
}
/**
 * 
 * @export
 * @interface QueriesDecileSalaryRanges
 */
export interface QueriesDecileSalaryRanges {
    /**
     * 
     * @type {string}
     * @memberof QueriesDecileSalaryRanges
     */
    'decileLabel': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesDecileSalaryRanges
     */
    'minimumSalary'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesDecileSalaryRanges
     */
    'maximumSalary'?: number | null;
}
/**
 * 
 * @export
 * @interface QueriesFocalGroupFilter
 */
export interface QueriesFocalGroupFilter {
    /**
     * 
     * @type {string}
     * @memberof QueriesFocalGroupFilter
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesFocalGroupFilter
     */
    'focalGroups': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesGetAnalysisDetailsResponse
 */
export interface QueriesGetAnalysisDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'analysisName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'selectedAnalysisType': EnumerationsAnalysisType;
    /**
     * 
     * @type {Array<TransferObjectsAnalysisTypeDTO>}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'analysisTypes': Array<TransferObjectsAnalysisTypeDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'useProjectData': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'disableUseProjectData': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'establishmentName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'planName'?: string | null;
    /**
     * 
     * @type {Array<TransferObjectsBAIImportTables2AnalysisDTO>}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'selectedBAITables': Array<TransferObjectsBAIImportTables2AnalysisDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAnalysisDetailsResponse
     */
    'analysisHasData': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetAnalysisFiltersResponse
 */
export interface QueriesGetAnalysisFiltersResponse {
    /**
     * 
     * @type {Array<TransferObjectsStrataWithValues>}
     * @memberof QueriesGetAnalysisFiltersResponse
     */
    'strataWithValues': Array<TransferObjectsStrataWithValues>;
    /**
     * 
     * @type {Array<QueriesGroups>}
     * @memberof QueriesGetAnalysisFiltersResponse
     */
    'groups': Array<QueriesGroups>;
}
/**
 * 
 * @export
 * @interface QueriesGetAnalysisRunBySummaryResponse
 */
export interface QueriesGetAnalysisRunBySummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'analysisName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'lastRunDate'?: string | null;
    /**
     * 
     * @type {TransferObjectsSelectedStrataFieldsDTO}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'strataSelections': TransferObjectsSelectedStrataFieldsDTO;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'selectionField': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'favoredOutcome': Array<string>;
    /**
     * 
     * @type {EnumerationsComparisonType}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'comparisonType': EnumerationsComparisonType;
    /**
     * 
     * @type {Array<TransferObjectsGroupSelectionsWithExclusionsDTO>}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'groupFields': Array<TransferObjectsGroupSelectionsWithExclusionsDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'importFileName': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'numberOfRecordsImported': number;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {TransferObjectsInProgressDataDTO}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'inProgressData': TransferObjectsInProgressDataDTO;
    /**
     * 
     * @type {TransferObjectsMeritVariableSelectionsDTO}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'meritVariableSelections': TransferObjectsMeritVariableSelectionsDTO;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'establishment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'company'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetAnalysisRunBySummaryResponse
     */
    'planName'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesGetApplicantFlowDataVisualizationRequest
 */
export interface QueriesGetApplicantFlowDataVisualizationRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetApplicantFlowDataVisualizationRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetApplicantFlowDataVisualizationRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetApplicantFlowDataVisualizationRequest
     */
    'strataValuesFilter': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesGetApplicantFlowDataVisualizationResponse
 */
export interface QueriesGetApplicantFlowDataVisualizationResponse {
    /**
     * 
     * @type {QueriesApplicantFlowTileData}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'tileData': QueriesApplicantFlowTileData;
    /**
     * 
     * @type {Array<DataVizTileGroupCountsDTO>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'top10DispCodeData': Array<DataVizTileGroupCountsDTO>;
    /**
     * 
     * @type {Array<DataVizDispCodeGroupChartData>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'top10RaceDispCodeData': Array<DataVizDispCodeGroupChartData>;
    /**
     * 
     * @type {Array<DataVizDispCodeGroupChartData>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'top10GenderDispCodeData': Array<DataVizDispCodeGroupChartData>;
    /**
     * 
     * @type {Array<DataVizTileGroupCountsDTO>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'raceExclusionData': Array<DataVizTileGroupCountsDTO>;
    /**
     * 
     * @type {Array<DataVizTileGroupCountsDTO>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'genderExclusionData': Array<DataVizTileGroupCountsDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'raceValues': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetApplicantFlowDataVisualizationResponse
     */
    'genderValues': Array<string>;
}
/**
 * 
 * @export
 * @interface QueriesGetBAIImportDataResponse
 */
export interface QueriesGetBAIImportDataResponse {
    /**
     * 
     * @type {Array<TransferObjectsBAIPlanDTO>}
     * @memberof QueriesGetBAIImportDataResponse
     */
    'plans': Array<TransferObjectsBAIPlanDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetBAIImportDataResponse
     */
    'message': string;
    /**
     * 
     * @type {TransferObjectsBAIPlanDTO}
     * @memberof QueriesGetBAIImportDataResponse
     */
    'selectedPlan': TransferObjectsBAIPlanDTO;
    /**
     * 
     * @type {Array<TransferObjectsAvailableBAITablesDTO>}
     * @memberof QueriesGetBAIImportDataResponse
     */
    'availableTables': Array<TransferObjectsAvailableBAITablesDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetExecutiveSummarySettingsResponse
 */
export interface QueriesGetExecutiveSummarySettingsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'hiringAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'competitivePromotionsAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'promoTermsTransfersAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'laborforceAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'totalSelectionsAnalysisID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'dataObservations1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'dataObservations2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'dataObservations3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'dataObservations4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'notificationID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'fileName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'fileSize'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'zipFileCreated'?: boolean | null;
    /**
     * 
     * @type {Array<QueriesAnalysisWithName>}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'analysisList': Array<QueriesAnalysisWithName>;
    /**
     * 
     * @type {EnumerationsExecutiveSummaryStatus}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'statusID': EnumerationsExecutiveSummaryStatus;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'lastDownloadDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'hiringAnalysisStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'competitivePromotionStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'promoTermsTransfersStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'laborforceStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetExecutiveSummarySettingsResponse
     */
    'totalSelectionsStrataFieldGUID'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesGetFrequencyAndSeverityChartsResponse
 */
export interface QueriesGetFrequencyAndSeverityChartsResponse {
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'standardDeviationSeverityByGroupField1': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'standardDeviationSeverityByGroupField2': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'standardDeviationSeverityByGroupField3': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'standardDeviationSeverityByGroupField4': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'standardDeviationSeverityByGroupField5': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'frequencyOfStatisticalImpactByGroupField1': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'frequencyOfStatisticalImpactByGroupField2': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'frequencyOfStatisticalImpactByGroupField3': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'frequencyOfStatisticalImpactByGroupField4': DataVizTileChartDataOverUnderCountDTO;
    /**
     * 
     * @type {DataVizTileChartDataOverUnderCountDTO}
     * @memberof QueriesGetFrequencyAndSeverityChartsResponse
     */
    'frequencyOfStatisticalImpactByGroupField5': DataVizTileChartDataOverUnderCountDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetGroupSelectionsResponse
 */
export interface QueriesGetGroupSelectionsResponse {
    /**
     * 
     * @type {EnumerationsComparisonType}
     * @memberof QueriesGetGroupSelectionsResponse
     */
    'selectedComparisonTypeID': EnumerationsComparisonType;
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetGroupSelectionsResponse
     */
    'possibleGroupFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {Array<QueriesGroupFields>}
     * @memberof QueriesGetGroupSelectionsResponse
     */
    'selectedGroupFields': Array<QueriesGroupFields>;
}


/**
 * 
 * @export
 * @interface QueriesGetImportDataResponse
 */
export interface QueriesGetImportDataResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetImportDataResponse
     */
    'importFileName'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetLaborMarketRequest
 */
export interface QueriesGetLaborMarketRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetLaborMarketRequest
     */
    'strataValuesFilter'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface QueriesGetLaborMarketResponse
 */
export interface QueriesGetLaborMarketResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'strataDisplay1Name': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'strataDisplay2Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'strataDisplay3Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'strataDisplay4Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'strataDisplay5Name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetLaborMarketResponse
     */
    'planCodeDisplayName'?: string | null;
    /**
     * 
     * @type {Array<DataVizTileLaborMarketTileDataDTO>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'tileData': Array<DataVizTileLaborMarketTileDataDTO>;
    /**
     * 
     * @type {Array<QueriesRepresentationVsLaborMarketChart>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'applicantPoolVsLaborMarketCharts': Array<QueriesRepresentationVsLaborMarketChart>;
    /**
     * 
     * @type {Array<QueriesRepresentationVsLaborMarketChart>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'workforceVsLaborMarketCharts': Array<QueriesRepresentationVsLaborMarketChart>;
    /**
     * 
     * @type {Array<QueriesSignificantResultsInBothAreasTable>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'significantResults': Array<QueriesSignificantResultsInBothAreasTable>;
    /**
     * 
     * @type {Array<QueriesTop10BiggestGapsTable>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'appPoolBiggestGaps': Array<QueriesTop10BiggestGapsTable>;
    /**
     * 
     * @type {Array<QueriesTop10BiggestGapsTable>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'workforceBiggestGaps': Array<QueriesTop10BiggestGapsTable>;
    /**
     * 
     * @type {QueriesGetFrequencyAndSeverityChartsResponse}
     * @memberof QueriesGetLaborMarketResponse
     */
    'applicantFrequencyAndSeverityCharts': QueriesGetFrequencyAndSeverityChartsResponse;
    /**
     * 
     * @type {QueriesGetFrequencyAndSeverityChartsResponse}
     * @memberof QueriesGetLaborMarketResponse
     */
    'workforceFrequencyAndSeverityCharts': QueriesGetFrequencyAndSeverityChartsResponse;
    /**
     * 
     * @type {Array<QueriesFocalGroupFilter>}
     * @memberof QueriesGetLaborMarketResponse
     */
    'focalGroupFilters': Array<QueriesFocalGroupFilter>;
}
/**
 * 
 * @export
 * @interface QueriesGetMeritVariablesResponse
 */
export interface QueriesGetMeritVariablesResponse {
    /**
     * 
     * @type {TransferObjectsMeritVariableSelectionsDTO}
     * @memberof QueriesGetMeritVariablesResponse
     */
    'meritVariables': TransferObjectsMeritVariableSelectionsDTO;
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetMeritVariablesResponse
     */
    'possibleFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetMeritVariablesResponse
     */
    'dateLabel': string;
}
/**
 * 
 * @export
 * @interface QueriesGetOverviewRequest
 */
export interface QueriesGetOverviewRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetOverviewRequest
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetOverviewRequest
     */
    'strataName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetOverviewRequest
     */
    'strataValues'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetOverviewRequest
     */
    'groupName'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetOverviewResponse
 */
export interface QueriesGetOverviewResponse {
    /**
     * 
     * @type {Array<DataVizOverviewPADTO>}
     * @memberof QueriesGetOverviewResponse
     */
    'overviewPAData'?: Array<DataVizOverviewPADTO> | null;
    /**
     * 
     * @type {QueriesMethodologyData}
     * @memberof QueriesGetOverviewResponse
     */
    'methodologyData': QueriesMethodologyData;
}
/**
 * 
 * @export
 * @interface QueriesGetProjectAnalysesResponse
 */
export interface QueriesGetProjectAnalysesResponse {
    /**
     * 
     * @type {Array<QueriesProjectAnalysesInfo>}
     * @memberof QueriesGetProjectAnalysesResponse
     */
    'projectAnalysesInfo': Array<QueriesProjectAnalysesInfo>;
}
/**
 * 
 * @export
 * @interface QueriesGetProjectSelectorResponse
 */
export interface QueriesGetProjectSelectorResponse {
    /**
     * 
     * @type {Array<TransferObjectsProjectSelectorDTO>}
     * @memberof QueriesGetProjectSelectorResponse
     */
    'projects': Array<TransferObjectsProjectSelectorDTO>;
    /**
     * 
     * @type {TransferObjectsProjectSelectorDTO}
     * @memberof QueriesGetProjectSelectorResponse
     */
    'selectedProject': TransferObjectsProjectSelectorDTO;
    /**
     * 
     * @type {Array<TransferObjectsDataVizAnalysisFilterDataDTO>}
     * @memberof QueriesGetProjectSelectorResponse
     */
    'analysesForSelectedProject': Array<TransferObjectsDataVizAnalysisFilterDataDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetProjectSharingDetailsResponse
 */
export interface QueriesGetProjectSharingDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'projectName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'snapshotDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'attorneyClientPrivilege': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'shareWithClients': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'dateChanged'?: string | null;
    /**
     * 
     * @type {Array<QueriesWFAUserAccess>}
     * @memberof QueriesGetProjectSharingDetailsResponse
     */
    'usersWithWFAAccess': Array<QueriesWFAUserAccess>;
}
/**
 * 
 * @export
 * @interface QueriesGetProportionalAnalysisSummaryResponse
 */
export interface QueriesGetProportionalAnalysisSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'analysisName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'selectedImportTables': Array<string>;
    /**
     * 
     * @type {Array<TransferObjectsProportionalAnalysisDTO>}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'proportionalAnalyses': Array<TransferObjectsProportionalAnalysisDTO>;
    /**
     * 
     * @type {TransferObjectsSelectedStrataFieldsDTO}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'strataSelections': TransferObjectsSelectedStrataFieldsDTO;
    /**
     * 
     * @type {Array<TransferObjectsGroupSelectionsWithExclusionsDTO>}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'groupFields': Array<TransferObjectsGroupSelectionsWithExclusionsDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {TransferObjectsInProgressDataDTO}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'inProgressData': TransferObjectsInProgressDataDTO;
    /**
     * 
     * @type {QueriesProportionalMeritVariablesDTO}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'meritVariableSelections': QueriesProportionalMeritVariablesDTO;
    /**
     * 
     * @type {Array<TransferObjectsApplyToAnalysisOptionDTO>}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'applyToAnalysisOptions': Array<TransferObjectsApplyToAnalysisOptionDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalAnalysisSummaryResponse
     */
    'planName': string;
}
/**
 * 
 * @export
 * @interface QueriesGetProportionalDataVisualizationRequest
 */
export interface QueriesGetProportionalDataVisualizationRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDataVisualizationRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalDataVisualizationRequest
     */
    'proportionalAnalysisID': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDataVisualizationRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDataVisualizationRequest
     */
    'strataValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDataVisualizationRequest
     */
    'groupFieldGUID'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetProportionalDataVisualizationResponse
 */
export interface QueriesGetProportionalDataVisualizationResponse {
    /**
     * 
     * @type {QueriesProportionalTopLevelTileData}
     * @memberof QueriesGetProportionalDataVisualizationResponse
     */
    'topLevelTileData': QueriesProportionalTopLevelTileData;
    /**
     * 
     * @type {QueriesGetFrequencyAndSeverityChartsResponse}
     * @memberof QueriesGetProportionalDataVisualizationResponse
     */
    'frequencyAndSeverityCharts': QueriesGetFrequencyAndSeverityChartsResponse;
}
/**
 * 
 * @export
 * @interface QueriesGetProportionalDefaultSignificantResultsSummaryRequest
 */
export interface QueriesGetProportionalDefaultSignificantResultsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'proportionalAnalysisID': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'numberOfResults': number;
    /**
     * 
     * @type {EnumerationsDataVizSortBy}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'sortByID': EnumerationsDataVizSortBy;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultSignificantResultsSummaryRequest
     */
    'groupFieldGUID'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesGetProportionalDefaultStatisticalValueSummaryRequest
 */
export interface QueriesGetProportionalDefaultStatisticalValueSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'viewByStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'groupFieldGUID'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'getAllRecords': boolean;
    /**
     * 
     * @type {EnumerationsSignificanceFilter}
     * @memberof QueriesGetProportionalDefaultStatisticalValueSummaryRequest
     */
    'significanceFilter': EnumerationsSignificanceFilter;
}


/**
 * 
 * @export
 * @interface QueriesGetProportionalGroupOptionsResponse
 */
export interface QueriesGetProportionalGroupOptionsResponse {
    /**
     * 
     * @type {Array<TransferObjectsGroupOptionsDTO>}
     * @memberof QueriesGetProportionalGroupOptionsResponse
     */
    'groupOptions': Array<TransferObjectsGroupOptionsDTO>;
    /**
     * 
     * @type {Array<TransferObjectsProjectFieldsDTO>}
     * @memberof QueriesGetProportionalGroupOptionsResponse
     */
    'projectFields': Array<TransferObjectsProjectFieldsDTO>;
    /**
     * 
     * @type {EnumerationsComparisonType}
     * @memberof QueriesGetProportionalGroupOptionsResponse
     */
    'selectedComparisonType': EnumerationsComparisonType;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetProportionalGroupOptionsResponse
     */
    'showCustomGroupFields': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetProportionalMeritVariablesResponse
 */
export interface QueriesGetProportionalMeritVariablesResponse {
    /**
     * 
     * @type {QueriesProportionalMeritVariablesDTO}
     * @memberof QueriesGetProportionalMeritVariablesResponse
     */
    'meritVariables': QueriesProportionalMeritVariablesDTO;
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetProportionalMeritVariablesResponse
     */
    'possibleFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {Array<TransferObjectsApplyToAnalysisOptionDTO>}
     * @memberof QueriesGetProportionalMeritVariablesResponse
     */
    'applyToAnalysesOptions': Array<TransferObjectsApplyToAnalysisOptionDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalMeritVariablesResponse
     */
    'dateLabel': string;
}
/**
 * 
 * @export
 * @interface QueriesGetProportionalSignificantResultsSummaryRequest
 */
export interface QueriesGetProportionalSignificantResultsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'proportionalAnalysisID': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'numberOfResults': number;
    /**
     * 
     * @type {EnumerationsDataVizSortBy}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'sortByID': EnumerationsDataVizSortBy;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'viewByStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalSignificantResultsSummaryRequest
     */
    'groupFieldGUID': string;
}


/**
 * 
 * @export
 * @interface QueriesGetProportionalStatisticalValueSummaryRequest
 */
export interface QueriesGetProportionalStatisticalValueSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'viewByStrataFieldGUID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {EnumerationsSignificanceFilter}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'significanceFilter': EnumerationsSignificanceFilter;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'pageSize': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {EnumerationsSortDirection}
     * @memberof QueriesGetProportionalStatisticalValueSummaryRequest
     */
    'sortDirection': EnumerationsSortDirection;
}


/**
 * 
 * @export
 * @interface QueriesGetProportionalStrataResponse
 */
export interface QueriesGetProportionalStrataResponse {
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetProportionalStrataResponse
     */
    'possibleFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {TransferObjectsSelectedStrataFieldsDTO}
     * @memberof QueriesGetProportionalStrataResponse
     */
    'selectedFields': TransferObjectsSelectedStrataFieldsDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetReportSettingsResponse
 */
export interface QueriesGetReportSettingsResponse {
    /**
     * 
     * @type {Array<TransferObjectsSplitResultsOptionsDTO>}
     * @memberof QueriesGetReportSettingsResponse
     */
    'splitResultsOptions': Array<TransferObjectsSplitResultsOptionsDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetReportSettingsResponse
     */
    'strataLevel1Name': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetReportSettingsResponse
     */
    'strataLevel1Count': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetReportSettingsResponse
     */
    'strataLevel2Name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetReportSettingsResponse
     */
    'strataLevel2Count'?: number | null;
}
/**
 * 
 * @export
 * @interface QueriesGetSRADataVisualizationRequest
 */
export interface QueriesGetSRADataVisualizationRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADataVisualizationRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADataVisualizationRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADataVisualizationRequest
     */
    'strataValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADataVisualizationRequest
     */
    'groupFieldGUID'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetSRADataVisualizationResponse
 */
export interface QueriesGetSRADataVisualizationResponse {
    /**
     * 
     * @type {QueriesSRATopLevelTileData}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'topLevelTileData': QueriesSRATopLevelTileData;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'standardDeviationSeverityByGroupField1': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'standardDeviationSeverityByGroupField2': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'standardDeviationSeverityByGroupField3': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'standardDeviationSeverityByGroupField4': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'standardDeviationSeverityByGroupField5': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'frequencyOfStatisticalImpactByGroupField1': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'frequencyOfStatisticalImpactByGroupField2': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'frequencyOfStatisticalImpactByGroupField3': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'frequencyOfStatisticalImpactByGroupField4': DataVizTileChartDataDTO;
    /**
     * 
     * @type {DataVizTileChartDataDTO}
     * @memberof QueriesGetSRADataVisualizationResponse
     */
    'frequencyOfStatisticalImpactByGroupField5': DataVizTileChartDataDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetSRADefaultSignificantResultsSummaryRequest
 */
export interface QueriesGetSRADefaultSignificantResultsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'numberOfResults': number;
    /**
     * 
     * @type {EnumerationsDataVizSortBy}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'sortByID': EnumerationsDataVizSortBy;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultSignificantResultsSummaryRequest
     */
    'groupFieldGUID'?: string | null;
}


/**
 * 
 * @export
 * @interface QueriesGetSRADefaultStatisticalValueSummaryRequest
 */
export interface QueriesGetSRADefaultStatisticalValueSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'viewByStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'groupFieldGUID'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'getAllRecords': boolean;
    /**
     * 
     * @type {EnumerationsSignificanceFilter}
     * @memberof QueriesGetSRADefaultStatisticalValueSummaryRequest
     */
    'significanceFilter': EnumerationsSignificanceFilter;
}


/**
 * 
 * @export
 * @interface QueriesGetSRASignificantResultsSummaryRequest
 */
export interface QueriesGetSRASignificantResultsSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'numberOfResults': number;
    /**
     * 
     * @type {EnumerationsDataVizSortBy}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'sortByID': EnumerationsDataVizSortBy;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'viewByStrataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRASignificantResultsSummaryRequest
     */
    'groupFieldGUID': string;
}


/**
 * 
 * @export
 * @interface QueriesGetSRAStatisticalValueSummaryRequest
 */
export interface QueriesGetSRAStatisticalValueSummaryRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'viewByStrataFieldGUID': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {EnumerationsSignificanceFilter}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'significanceFilter': EnumerationsSignificanceFilter;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'pageSize': number;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'sortColumn'?: string | null;
    /**
     * 
     * @type {EnumerationsSortDirection}
     * @memberof QueriesGetSRAStatisticalValueSummaryRequest
     */
    'sortDirection': EnumerationsSortDirection;
}


/**
 * 
 * @export
 * @interface QueriesGetSelectionFieldsResponse
 */
export interface QueriesGetSelectionFieldsResponse {
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetSelectionFieldsResponse
     */
    'possibleFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSelectionFieldsResponse
     */
    'selectedFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSelectionFieldsResponse
     */
    'displayName': string;
    /**
     * 
     * @type {Array<TransferObjectsFavoredOutcomeValuesDTO>}
     * @memberof QueriesGetSelectionFieldsResponse
     */
    'outcomes': Array<TransferObjectsFavoredOutcomeValuesDTO>;
}
/**
 * 
 * @export
 * @interface QueriesGetStrataResponse
 */
export interface QueriesGetStrataResponse {
    /**
     * 
     * @type {Array<TransferObjectsAnalysisFieldsDTO>}
     * @memberof QueriesGetStrataResponse
     */
    'possibleFields': Array<TransferObjectsAnalysisFieldsDTO>;
    /**
     * 
     * @type {TransferObjectsSelectedStrataFieldsDTO}
     * @memberof QueriesGetStrataResponse
     */
    'selectedFields': TransferObjectsSelectedStrataFieldsDTO;
}
/**
 * 
 * @export
 * @interface QueriesGetSummariesExportSettingsResponse
 */
export interface QueriesGetSummariesExportSettingsResponse {
    /**
     * 
     * @type {EnumerationsSummaryExportSheet}
     * @memberof QueriesGetSummariesExportSettingsResponse
     */
    'summaryExportSheetID': EnumerationsSummaryExportSheet;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSummariesExportSettingsResponse
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetSummariesExportSettingsResponse
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGetSummariesExportSettingsResponse
     */
    'selected': boolean;
}


/**
 * 
 * @export
 * @interface QueriesGetWorkforceRepresentationRequest
 */
export interface QueriesGetWorkforceRepresentationRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetWorkforceRepresentationRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetWorkforceRepresentationRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesGetWorkforceRepresentationRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesGetWorkforceRepresentationRequest
     */
    'groupFieldGUID'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesGetWorkforceRepresentationResponse
 */
export interface QueriesGetWorkforceRepresentationResponse {
    /**
     * 
     * @type {string}
     * @memberof QueriesGetWorkforceRepresentationResponse
     */
    'secondLowestStrataName': string;
    /**
     * 
     * @type {DataVizTileWorkforceRepresentationTileData}
     * @memberof QueriesGetWorkforceRepresentationResponse
     */
    'tileData': DataVizTileWorkforceRepresentationTileData;
    /**
     * 
     * @type {Array<QueriesWorkforceRepresentationCharts>}
     * @memberof QueriesGetWorkforceRepresentationResponse
     */
    'workforceRepresentationCharts': Array<QueriesWorkforceRepresentationCharts>;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesGetWorkforceRepresentationResponse
     */
    'workforceRepresentationOverallTenure': Array<QueriesWorkforceChartData>;
}
/**
 * 
 * @export
 * @interface QueriesGroupFields
 */
export interface QueriesGroupFields {
    /**
     * 
     * @type {string}
     * @memberof QueriesGroupFields
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGroupFields
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGroupFields
     */
    'allValuesForComparison': boolean;
    /**
     * 
     * @type {Array<QueriesGroupValues>}
     * @memberof QueriesGroupFields
     */
    'values': Array<QueriesGroupValues>;
}
/**
 * 
 * @export
 * @interface QueriesGroupValues
 */
export interface QueriesGroupValues {
    /**
     * 
     * @type {string}
     * @memberof QueriesGroupValues
     */
    'fieldValue': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGroupValues
     */
    'excludeAsReferenceGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGroupValues
     */
    'excludeAsFocalGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGroupValues
     */
    'referenceGroup': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesGroupValues
     */
    'comparisonGroup': boolean;
}
/**
 * 
 * @export
 * @interface QueriesGroups
 */
export interface QueriesGroups {
    /**
     * 
     * @type {string}
     * @memberof QueriesGroups
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesGroups
     */
    'groupDisplayName': string;
}
/**
 * 
 * @export
 * @interface QueriesLaborMarketBarData
 */
export interface QueriesLaborMarketBarData {
    /**
     * 
     * @type {string}
     * @memberof QueriesLaborMarketBarData
     */
    'barLabel': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesLaborMarketBarData
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface QueriesLaborMarketChartData
 */
export interface QueriesLaborMarketChartData {
    /**
     * 
     * @type {string}
     * @memberof QueriesLaborMarketChartData
     */
    'axisLabel': string;
    /**
     * 
     * @type {Array<QueriesLaborMarketBarData>}
     * @memberof QueriesLaborMarketChartData
     */
    'data': Array<QueriesLaborMarketBarData>;
}
/**
 * 
 * @export
 * @interface QueriesMeritVariableInfo
 */
export interface QueriesMeritVariableInfo {
    /**
     * 
     * @type {string}
     * @memberof QueriesMeritVariableInfo
     */
    'displayName': string;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesMeritVariableInfo
     */
    'applyToAnalyses': Array<EnumerationsProportionalAnalyses>;
}
/**
 * 
 * @export
 * @interface QueriesMethodologyData
 */
export interface QueriesMethodologyData {
    /**
     * 
     * @type {string}
     * @memberof QueriesMethodologyData
     */
    'rosterSnapshot': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesMethodologyData
     */
    'transactionStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesMethodologyData
     */
    'transactionEndDate'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesMethodologyData
     */
    'totalEmployees': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesMethodologyData
     */
    'strataNames'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesMethodologyData
     */
    'showLaborMarket': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesMethodologyData
     */
    'showSRA': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesMethodologyData
     */
    'showProportional': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesMethodologyData
     */
    'showWorkforceInsights': boolean;
}
/**
 * 
 * @export
 * @interface QueriesProjectAnalysesInfo
 */
export interface QueriesProjectAnalysesInfo {
    /**
     * 
     * @type {string}
     * @memberof QueriesProjectAnalysesInfo
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProjectAnalysesInfo
     */
    'analysisName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof QueriesProjectAnalysesInfo
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsAnalysisCategory}
     * @memberof QueriesProjectAnalysesInfo
     */
    'analysisCategoryID': EnumerationsAnalysisCategory;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesProjectAnalysesInfo
     */
    'useProjectData': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesProjectAnalysesInfo
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {EnumerationsAnalysisSteps}
     * @memberof QueriesProjectAnalysesInfo
     */
    'lastCompletedStepID': EnumerationsAnalysisSteps;
    /**
     * 
     * @type {string}
     * @memberof QueriesProjectAnalysesInfo
     */
    'lastRunDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesProjectAnalysesInfo
     */
    'canApplyMeritVariables': boolean;
    /**
     * 
     * @type {Array<QueriesStrataInfo>}
     * @memberof QueriesProjectAnalysesInfo
     */
    'strataInfo': Array<QueriesStrataInfo>;
    /**
     * 
     * @type {Array<QueriesMeritVariableInfo>}
     * @memberof QueriesProjectAnalysesInfo
     */
    'meritVariableInfo': Array<QueriesMeritVariableInfo>;
    /**
     * 
     * @type {Array<TransferObjectsProjectGroupSelectionsDTO>}
     * @memberof QueriesProjectAnalysesInfo
     */
    'groupSelections': Array<TransferObjectsProjectGroupSelectionsDTO>;
    /**
     * 
     * @type {Array<TransferObjectsProjectImportTableCountsDTO>}
     * @memberof QueriesProjectAnalysesInfo
     */
    'importTables': Array<TransferObjectsProjectImportTableCountsDTO>;
    /**
     * 
     * @type {Array<TransferObjectsProjectFavoredOutcomeDTO>}
     * @memberof QueriesProjectAnalysesInfo
     */
    'favoredOutcomes': Array<TransferObjectsProjectFavoredOutcomeDTO>;
}


/**
 * 
 * @export
 * @interface QueriesProportionalMeritVariablesDTO
 */
export interface QueriesProportionalMeritVariablesDTO {
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'fieldGUID1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'displayName1': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'fieldGUID2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'displayName2': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'fieldGUID3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'displayName3': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'fieldGUID4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'displayName4': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'fieldGUID5'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'displayName5': string;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'applyToAnalyses1': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'applyToAnalyses2': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'applyToAnalyses3': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'applyToAnalyses4': Array<EnumerationsProportionalAnalyses>;
    /**
     * 
     * @type {Array<EnumerationsProportionalAnalyses>}
     * @memberof QueriesProportionalMeritVariablesDTO
     */
    'applyToAnalyses5': Array<EnumerationsProportionalAnalyses>;
}
/**
 * 
 * @export
 * @interface QueriesProportionalTopLevelTileData
 */
export interface QueriesProportionalTopLevelTileData {
    /**
     * 
     * @type {number}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'totalPersonnelActions': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'totalPersonnel': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'percentagePersonnelActionRate': number;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'strata1Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'strata2Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'strata3Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'strata4Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesProportionalTopLevelTileData
     */
    'strata5Tile': DataVizTileStrataTileDataDTO;
}
/**
 * 
 * @export
 * @interface QueriesRefreshTop10BiggestGapsTableRequest
 */
export interface QueriesRefreshTop10BiggestGapsTableRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'strataValuesFilter'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'groupFieldValueFilter'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesRefreshTop10BiggestGapsTableRequest
     */
    'selectedCountFilter'?: number | null;
}


/**
 * 
 * @export
 * @interface QueriesRefreshTop10DispCodeForGroupRequest
 */
export interface QueriesRefreshTop10DispCodeForGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10DispCodeForGroupRequest
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesRefreshTop10DispCodeForGroupRequest
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesRefreshTop10DispCodeForGroupRequest
     */
    'strataValuesFilter': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueriesRefreshTop10DispCodeForGroupRequest
     */
    'groupValues'?: Array<string> | null;
    /**
     * 
     * @type {EnumerationsGroupOptions}
     * @memberof QueriesRefreshTop10DispCodeForGroupRequest
     */
    'groupOptionID': EnumerationsGroupOptions;
}


/**
 * 
 * @export
 * @interface QueriesRepresentationVsLaborMarketChart
 */
export interface QueriesRepresentationVsLaborMarketChart {
    /**
     * 
     * @type {string}
     * @memberof QueriesRepresentationVsLaborMarketChart
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {Array<QueriesLaborMarketChartData>}
     * @memberof QueriesRepresentationVsLaborMarketChart
     */
    'data': Array<QueriesLaborMarketChartData>;
}
/**
 * 
 * @export
 * @interface QueriesSRATopLevelTileData
 */
export interface QueriesSRATopLevelTileData {
    /**
     * 
     * @type {number}
     * @memberof QueriesSRATopLevelTileData
     */
    'totalHires': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesSRATopLevelTileData
     */
    'totalApplicants': number;
    /**
     * 
     * @type {number}
     * @memberof QueriesSRATopLevelTileData
     */
    'percentageHireRate': number;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesSRATopLevelTileData
     */
    'strata1Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesSRATopLevelTileData
     */
    'strata2Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesSRATopLevelTileData
     */
    'strata3Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesSRATopLevelTileData
     */
    'strata4Tile': DataVizTileStrataTileDataDTO;
    /**
     * 
     * @type {DataVizTileStrataTileDataDTO}
     * @memberof QueriesSRATopLevelTileData
     */
    'strata5Tile': DataVizTileStrataTileDataDTO;
}
/**
 * 
 * @export
 * @interface QueriesSignificantResultsInBothAreasTable
 */
export interface QueriesSignificantResultsInBothAreasTable {
    /**
     * 
     * @type {string}
     * @memberof QueriesSignificantResultsInBothAreasTable
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {Array<DataVizSignificantResultsInBothAreasDTO>}
     * @memberof QueriesSignificantResultsInBothAreasTable
     */
    'data': Array<DataVizSignificantResultsInBothAreasDTO>;
}
/**
 * 
 * @export
 * @interface QueriesStrataInfo
 */
export interface QueriesStrataInfo {
    /**
     * 
     * @type {string}
     * @memberof QueriesStrataInfo
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesStrataInfo
     */
    'runAnalysisOn': boolean;
}
/**
 * 
 * @export
 * @interface QueriesTop10BiggestGapsTable
 */
export interface QueriesTop10BiggestGapsTable {
    /**
     * 
     * @type {string}
     * @memberof QueriesTop10BiggestGapsTable
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {Array<DataVizTop10BiggestGapsDTO>}
     * @memberof QueriesTop10BiggestGapsTable
     */
    'data': Array<DataVizTop10BiggestGapsDTO>;
}
/**
 * 
 * @export
 * @interface QueriesWFAUserAccess
 */
export interface QueriesWFAUserAccess {
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'userID': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'roleDescription': string;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesWFAUserAccess
     */
    'salaryAccess': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof QueriesWFAUserAccess
     */
    'projectAccess': boolean;
    /**
     * 
     * @type {string}
     * @memberof QueriesWFAUserAccess
     */
    'lastEmailSentDate'?: string | null;
}
/**
 * 
 * @export
 * @interface QueriesWorkforceChartData
 */
export interface QueriesWorkforceChartData {
    /**
     * 
     * @type {string}
     * @memberof QueriesWorkforceChartData
     */
    'axisLabel': string;
    /**
     * 
     * @type {Array<QueriesWorkforceChartGroupData>}
     * @memberof QueriesWorkforceChartData
     */
    'data': Array<QueriesWorkforceChartGroupData>;
}
/**
 * 
 * @export
 * @interface QueriesWorkforceChartGroupData
 */
export interface QueriesWorkforceChartGroupData {
    /**
     * 
     * @type {string}
     * @memberof QueriesWorkforceChartGroupData
     */
    'barLabel': string;
    /**
     * 
     * @type {number}
     * @memberof QueriesWorkforceChartGroupData
     */
    'count'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof QueriesWorkforceChartGroupData
     */
    'percent'?: number | null;
}
/**
 * 
 * @export
 * @interface QueriesWorkforceRepresentationCharts
 */
export interface QueriesWorkforceRepresentationCharts {
    /**
     * 
     * @type {string}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'workforceRepresentationOverview': Array<QueriesWorkforceChartData>;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'workforceRepresentationPayDecile'?: Array<QueriesWorkforceChartData> | null;
    /**
     * 
     * @type {Array<QueriesDecileSalaryRanges>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'decileSalaryRanges'?: Array<QueriesDecileSalaryRanges> | null;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'workforceRepresentationPayGrade'?: Array<QueriesWorkforceChartData> | null;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'workforceRepresentationSecondLowest': Array<QueriesWorkforceChartData>;
    /**
     * 
     * @type {Array<QueriesWorkforceChartData>}
     * @memberof QueriesWorkforceRepresentationCharts
     */
    'workforceRepresentationTenure': Array<QueriesWorkforceChartData>;
}
/**
 * 
 * @export
 * @interface TransferObjectsAnalysisDTO
 */
export interface TransferObjectsAnalysisDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisDTO
     */
    'lastRunDate'?: string | null;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsAnalysisDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsAnalysisCategory}
     * @memberof TransferObjectsAnalysisDTO
     */
    'analysisCategoryID': EnumerationsAnalysisCategory;
    /**
     * 
     * @type {EnumerationsAnalysisSteps}
     * @memberof TransferObjectsAnalysisDTO
     */
    'lastCompletedStepID': EnumerationsAnalysisSteps;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisDTO
     */
    'isCalculated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisDTO
     */
    'useProjectData': boolean;
}


/**
 * 
 * @export
 * @interface TransferObjectsAnalysisFieldsDTO
 */
export interface TransferObjectsAnalysisFieldsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'fieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'containsBlankFieldValues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'allValuesAreBlank': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'isDate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'isNumeric': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAnalysisFieldsDTO
     */
    'isSelected': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsAnalysisTypeDTO
 */
export interface TransferObjectsAnalysisTypeDTO {
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsAnalysisTypeDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisTypeDTO
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisTypeDTO
     */
    'displayName': string;
    /**
     * 
     * @type {EnumerationsAnalysisCategory}
     * @memberof TransferObjectsAnalysisTypeDTO
     */
    'analysisCategoryID': EnumerationsAnalysisCategory;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAnalysisTypeDTO
     */
    'analysisCategory': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsApplyToAnalysisOptionDTO
 */
export interface TransferObjectsApplyToAnalysisOptionDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsApplyToAnalysisOptionDTO
     */
    'proportionalAnalysisID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsApplyToAnalysisOptionDTO
     */
    'proportionalAnalysisName': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsAvailableBAITablesDTO
 */
export interface TransferObjectsAvailableBAITablesDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'tableCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'tableName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'actionTypeID': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'isUPA': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'jobs': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'positive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsAvailableBAITablesDTO
     */
    'useAggregateAction': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsBAIImportTables2AnalysisDTO
 */
export interface TransferObjectsBAIImportTables2AnalysisDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'baiImportTableID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'tableCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'tableName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'selectedForAnalysis': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'actionTypeID': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'isUPA': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'jobs': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'positive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsBAIImportTables2AnalysisDTO
     */
    'useAggregateAction': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsBAIPlanDTO
 */
export interface TransferObjectsBAIPlanDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'baiPlanID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'company': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'establishment': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'planName': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'baiClientID': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsBAIPlanDTO
     */
    'availCalcFlag': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsDataVizAnalysisFilterDataDTO
 */
export interface TransferObjectsDataVizAnalysisFilterDataDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'analysisName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsAnalysisCategory}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'analysisCategoryID': EnumerationsAnalysisCategory;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsDataVizAnalysisFilterDataDTO
     */
    'proportionalAnalysisName'?: string | null;
}


/**
 * 
 * @export
 * @interface TransferObjectsExportSummariesDTO
 */
export interface TransferObjectsExportSummariesDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsExportSummariesDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsExportSummariesDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsExportSummariesDTO
     */
    'strataLevelFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsExportSummariesDTO
     */
    'projectID': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsExportSummariesRequest
 */
export interface TransferObjectsExportSummariesRequest {
    /**
     * 
     * @type {Array<TransferObjectsExportSummariesDTO>}
     * @memberof TransferObjectsExportSummariesRequest
     */
    'summaries': Array<TransferObjectsExportSummariesDTO>;
}
/**
 * 
 * @export
 * @interface TransferObjectsFavoredOutcomeValuesDTO
 */
export interface TransferObjectsFavoredOutcomeValuesDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsFavoredOutcomeValuesDTO
     */
    'fieldValue': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsFavoredOutcomeValuesDTO
     */
    'selected': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsGroupOptionsDTO
 */
export interface TransferObjectsGroupOptionsDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsGroupOptionsDTO
     */
    'groupOptionID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGroupOptionsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsGroupOptionsDTO
     */
    'selected': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsGroupSelectionsWithExclusionsDTO
 */
export interface TransferObjectsGroupSelectionsWithExclusionsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsGroupSelectionsWithExclusionsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsGroupSelectionsWithExclusionsDTO
     */
    'excludedAsFocalGroup': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsGroupSelectionsWithExclusionsDTO
     */
    'excludedAsReferenceGroup': Array<string>;
}
/**
 * 
 * @export
 * @interface TransferObjectsInProgressDataDTO
 */
export interface TransferObjectsInProgressDataDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsInProgressDataDTO
     */
    'alreadyInProgress': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsInProgressDataDTO
     */
    'calculateProgressID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsInProgressDataDTO
     */
    'reportDownloadID'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsInProgressDataDTO
     */
    'percentComplete': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsInProgressDataDTO
     */
    'stepDescription': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsManageProjectsDTO
 */
export interface TransferObjectsManageProjectsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'isActive': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'transactionStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'transactionEndDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'snapshotDate': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'attorneyClientPrivilege': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'acpNotice'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'shareWithClients': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'shareStatusChangeDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'displayNameForDepartment': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'importStepCompleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'displayNameForPlanCode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsManageProjectsDTO
     */
    'displayNameForJobGroup': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsMeritVariableSelectionsDTO
 */
export interface TransferObjectsMeritVariableSelectionsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'fieldGUID1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'displayName1': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'fieldGUID2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'displayName2': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'fieldGUID3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'displayName3': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'fieldGUID4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'displayName4': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'fieldGUID5'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsMeritVariableSelectionsDTO
     */
    'displayName5': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectAccessDTO
 */
export interface TransferObjectsProjectAccessDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'snapshotDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'lastRunDate': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'analysisCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'shareWithClients': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectAccessDTO
     */
    'projectIdentifier': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectFavoredOutcomeDTO
 */
export interface TransferObjectsProjectFavoredOutcomeDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFavoredOutcomeDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFavoredOutcomeDTO
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFavoredOutcomeDTO
     */
    'fieldValue': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFavoredOutcomeDTO
     */
    'selected': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectFieldsDTO
 */
export interface TransferObjectsProjectFieldsDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'fieldID': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'fieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'fieldName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'containsBlankFieldValues': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'allValuesAreBlank': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'isDate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'isNumeric': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsProjectFieldsDTO
     */
    'sortOrder': number;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectGroupSelectionsDTO
 */
export interface TransferObjectsProjectGroupSelectionsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectGroupSelectionsDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectGroupSelectionsDTO
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectGroupSelectionsDTO
     */
    'excludedFocalGroups': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectGroupSelectionsDTO
     */
    'excludedRefGroups': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectImportTableCountsDTO
 */
export interface TransferObjectsProjectImportTableCountsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectImportTableCountsDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectImportTableCountsDTO
     */
    'tableNameWithCount': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsProjectSelectorDTO
 */
export interface TransferObjectsProjectSelectorDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'projectID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'companyName': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'isActive': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'attorneyClientPrivilege': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'transactionStartDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'transactionEndDate'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'snapshotDate': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProjectSelectorDTO
     */
    'acpNotice'?: string | null;
}
/**
 * 
 * @export
 * @interface TransferObjectsProportionalAnalyses2TableTypeNameDTO
 */
export interface TransferObjectsProportionalAnalyses2TableTypeNameDTO {
    /**
     * 
     * @type {EnumerationsReportGroup}
     * @memberof TransferObjectsProportionalAnalyses2TableTypeNameDTO
     */
    'reportGroupID': EnumerationsReportGroup;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProportionalAnalyses2TableTypeNameDTO
     */
    'displayName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsProportionalAnalyses2TableTypeNameDTO
     */
    'requiredTables': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsProportionalAnalyses2TableTypeNameDTO
     */
    'optionalTables': Array<string>;
}


/**
 * 
 * @export
 * @interface TransferObjectsProportionalAnalysisDTO
 */
export interface TransferObjectsProportionalAnalysisDTO {
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsProportionalAnalysisDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsProportionalAnalysisDTO
     */
    'displayName': string;
    /**
     * 
     * @type {EnumerationsReportGroup}
     * @memberof TransferObjectsProportionalAnalysisDTO
     */
    'reportGroupID': EnumerationsReportGroup;
}


/**
 * 
 * @export
 * @interface TransferObjectsReportExportDTO
 */
export interface TransferObjectsReportExportDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportExportDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsReportExportDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsReportExportDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
}


/**
 * 
 * @export
 * @interface TransferObjectsReportsDTO
 */
export interface TransferObjectsReportsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportsDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsReportGroup}
     * @memberof TransferObjectsReportsDTO
     */
    'reportGroupID': EnumerationsReportGroup;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportsDTO
     */
    'groupName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsReportsDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsReportsDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsReportsDTO
     */
    'reportName': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsResponseDTO
 */
export interface TransferObjectsResponseDTO {
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsResponseDTO
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsResponseDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsSelectedStrataFieldsDTO
 */
export interface TransferObjectsSelectedStrataFieldsDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'fieldGUID1': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'displayName1': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'runAnalysisOn1': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'fieldGUID2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'displayName2': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'runAnalysisOn2': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'fieldGUID3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'displayName3': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'runAnalysisOn3': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'fieldGUID4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'displayName4': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'runAnalysisOn4': boolean;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'fieldGUID5'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSelectedStrataFieldsDTO
     */
    'displayName5': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsSignificantResultsSummaryDTO
 */
export interface TransferObjectsSignificantResultsSummaryDTO {
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataLevel': number;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'hierarchy': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'parentNode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'topLevelNode': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'groupFieldGUID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'groupDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataFieldValue': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataField1Value': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataField2Value': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataField3Value': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataField4Value': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'strataField5Value': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedGroup': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceGroup': string;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedStartingCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedSelectedCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedSelectionRate': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceStartingCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceSelectedCount': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceSelectionRate': number;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'statValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'shortfall'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedMeritVariable1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceMeritVariable1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedMeritVariable2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceMeritVariable2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedMeritVariable3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceMeritVariable3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedMeritVariable4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceMeritVariable4'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'impactedMeritVariable5'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'referenceMeritVariable5'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'notes': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSignificantResultsSummaryDTO
     */
    'representation': string;
}
/**
 * 
 * @export
 * @interface TransferObjectsSplitResultsOptionsDTO
 */
export interface TransferObjectsSplitResultsOptionsDTO {
    /**
     * 
     * @type {EnumerationsSplitResultsOptions}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'splitResultsOptionsID': EnumerationsSplitResultsOptions;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'message': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'selected': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsSplitResultsOptionsDTO
     */
    'enabled': boolean;
}


/**
 * 
 * @export
 * @interface TransferObjectsStrataFieldDTO
 */
export interface TransferObjectsStrataFieldDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsStrataFieldDTO
     */
    'fieldGUID': string;
    /**
     * 
     * @type {boolean}
     * @memberof TransferObjectsStrataFieldDTO
     */
    'runAnalysisOn': boolean;
}
/**
 * 
 * @export
 * @interface TransferObjectsStrataWithValues
 */
export interface TransferObjectsStrataWithValues {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsStrataWithValues
     */
    'strataFieldGUID'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsStrataWithValues
     */
    'strataDisplayName': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransferObjectsStrataWithValues
     */
    'values': Array<string>;
}
/**
 * 
 * @export
 * @interface TransferObjectsSummariesDTO
 */
export interface TransferObjectsSummariesDTO {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSummariesDTO
     */
    'analysisID': string;
    /**
     * 
     * @type {EnumerationsSummaryGroup}
     * @memberof TransferObjectsSummariesDTO
     */
    'summaryGroupID': EnumerationsSummaryGroup;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSummariesDTO
     */
    'groupName': string;
    /**
     * 
     * @type {EnumerationsAnalysisType}
     * @memberof TransferObjectsSummariesDTO
     */
    'analysisTypeID': EnumerationsAnalysisType;
    /**
     * 
     * @type {EnumerationsProportionalAnalyses}
     * @memberof TransferObjectsSummariesDTO
     */
    'proportionalAnalysisID': EnumerationsProportionalAnalyses;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSummariesDTO
     */
    'displayName': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsSummariesDTO
     */
    'analysisFieldGUID': string;
}


/**
 * 
 * @export
 * @interface TransferObjectsViewByOptions
 */
export interface TransferObjectsViewByOptions {
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsViewByOptions
     */
    'strataGUID': string;
    /**
     * 
     * @type {string}
     * @memberof TransferObjectsViewByOptions
     */
    'strataDisplayName': string;
}

/**
 * AnalysisApi - axios parameter creator
 * @export
 */
export const AnalysisApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisAnalysisTypesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/analysis-types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisAvailableTablesProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraAnalysisAvailableTablesProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Analysis/available-tables/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost: async (analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost', 'analysisID', analysisID)
            // verify required parameter 'analysisCategoryID' is not null or undefined
            assertParamExists('apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost', 'analysisCategoryID', analysisCategoryID)
            const localVarPath = `/api/sra/Analysis/calculate/{analysisID}/{analysisCategoryID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)))
                .replace(`{${"analysisCategoryID"}}`, encodeURIComponent(String(analysisCategoryID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} calculateProgressID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCalculateProgressIDCancelCalculationPost: async (calculateProgressID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculateProgressID' is not null or undefined
            assertParamExists('apiSraAnalysisCalculateProgressIDCancelCalculationPost', 'calculateProgressID', calculateProgressID)
            const localVarPath = `/api/sra/Analysis/{calculateProgressID}/cancel-calculation`
                .replace(`{${"calculateProgressID"}}`, encodeURIComponent(String(calculateProgressID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateMeritVariablesRequest} [commandsCreateMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateMeritVariablesPost: async (commandsCreateMeritVariablesRequest?: CommandsCreateMeritVariablesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/create-merit-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateMeritVariablesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateProportionalMeritVariablesRequest} [commandsCreateProportionalMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateProportionalMeritVariablesPost: async (commandsCreateProportionalMeritVariablesRequest?: CommandsCreateProportionalMeritVariablesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/create-proportional-merit-variables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateProportionalMeritVariablesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateProportionalStrataRequest} [commandsCreateProportionalStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateProportionalStrataPost: async (commandsCreateProportionalStrataRequest?: CommandsCreateProportionalStrataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/create-proportional-strata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateProportionalStrataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateStrataRequest} [commandsCreateStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateStrataPost: async (commandsCreateStrataRequest?: CommandsCreateStrataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/create-strata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateStrataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsDeleteAnalysisRequest} [commandsDeleteAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisDelete: async (commandsDeleteAnalysisRequest?: CommandsDeleteAnalysisRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsDeleteAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisDetailsAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisDetailsAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/details/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [analysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupOptionsGet: async (analysisID?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/group-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (analysisID !== undefined) {
                localVarQueryParameter['analysisID'] = analysisID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisGroupSelectionsAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/group-selections/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateGroupSelectionsRequest} [commandsCreateGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsPost: async (commandsCreateGroupSelectionsRequest?: CommandsCreateGroupSelectionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/group-selections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateGroupSelectionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} selectedFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet: async (analysisID: string, selectedFieldGUID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet', 'analysisID', analysisID)
            // verify required parameter 'selectedFieldGUID' is not null or undefined
            assertParamExists('apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet', 'selectedFieldGUID', selectedFieldGUID)
            const localVarPath = `/api/sra/Analysis/group-selections-values/{analysisID}/{selectedFieldGUID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)))
                .replace(`{${"selectedFieldGUID"}}`, encodeURIComponent(String(selectedFieldGUID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisImportAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisImportAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/import/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisImportAnalysisIDPost: async (analysisID: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisImportAnalysisIDPost', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/import/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisMeritVariablesAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisMeritVariablesAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/merit-variables/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} analysisFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet: async (analysisID: string, analysisFieldGUID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet', 'analysisID', analysisID)
            // verify required parameter 'analysisFieldGUID' is not null or undefined
            assertParamExists('apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet', 'analysisFieldGUID', analysisFieldGUID)
            const localVarPath = `/api/sra/Analysis/outcomes/{analysisID}/{analysisFieldGUID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)))
                .replace(`{${"analysisFieldGUID"}}`, encodeURIComponent(String(analysisFieldGUID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisOutcomesAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/outcomes/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateFavoredOutcomeSelectionsRequest} [commandsCreateFavoredOutcomeSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesPost: async (commandsCreateFavoredOutcomeSelectionsRequest?: CommandsCreateFavoredOutcomeSelectionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/outcomes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateFavoredOutcomeSelectionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateAnalysisRequest} [commandsCreateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisPost: async (commandsCreateAnalysisRequest?: CommandsCreateAnalysisRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraAnalysisProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Analysis/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalAnalysesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/proportional-analyses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateProportionalGroupSelectionsRequest} [commandsCreateProportionalGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalGroupSelectionsPost: async (commandsCreateProportionalGroupSelectionsRequest?: CommandsCreateProportionalGroupSelectionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis/proportional-group-selections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateProportionalGroupSelectionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalMeritVariablesAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisProportionalMeritVariablesAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/proportional-merit-variables/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalStrataAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisProportionalStrataAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/proportional-strata/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalSummaryAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisProportionalSummaryAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/proportional-summary/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateAnalysisRequest} [commandsUpdateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisPut: async (commandsUpdateAnalysisRequest?: CommandsUpdateAnalysisRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateAnalysisRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisStrataAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisStrataAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/strata/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisSummaryAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraAnalysisSummaryAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Analysis/summary/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalysisApi - functional programming interface
 * @export
 */
export const AnalysisApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalysisApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisAnalysisTypesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsAnalysisTypeDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisAnalysisTypesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisAnalysisTypesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisAvailableTablesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelsBAIImportTables>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisAvailableTablesProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisAvailableTablesProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransferObjectsInProgressDataDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID, analysisCategoryID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} calculateProgressID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCalculateProgressIDCancelCalculationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateMeritVariablesRequest} [commandsCreateMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest?: CommandsCreateMeritVariablesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCreateMeritVariablesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateProportionalMeritVariablesRequest} [commandsCreateProportionalMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest?: CommandsCreateProportionalMeritVariablesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCreateProportionalMeritVariablesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateProportionalStrataRequest} [commandsCreateProportionalStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest?: CommandsCreateProportionalStrataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateProportionalStrataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCreateProportionalStrataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateStrataRequest} [commandsCreateStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest?: CommandsCreateStrataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateStrataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisCreateStrataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsDeleteAnalysisRequest} [commandsDeleteAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisDelete(commandsDeleteAnalysisRequest?: CommandsDeleteAnalysisRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsDeleteAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisDelete(commandsDeleteAnalysisRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisDetailsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAnalysisDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisDetailsAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisDetailsAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [analysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisGroupOptionsGet(analysisID?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProportionalGroupOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisGroupOptionsGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisGroupOptionsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetGroupSelectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisGroupSelectionsAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateGroupSelectionsRequest} [commandsCreateGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest?: CommandsCreateGroupSelectionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisGroupSelectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} selectedFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID: string, selectedFieldGUID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID, selectedFieldGUID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisImportAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetImportDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisImportAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisImportAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisImportAnalysisIDPost(analysisID: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsImportSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisImportAnalysisIDPost(analysisID, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisImportAnalysisIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetMeritVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisMeritVariablesAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} analysisFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID: string, analysisFieldGUID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsFavoredOutcomeValuesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID, analysisFieldGUID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisOutcomesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSelectionFieldsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisOutcomesAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisOutcomesAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateFavoredOutcomeSelectionsRequest} [commandsCreateFavoredOutcomeSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest?: CommandsCreateFavoredOutcomeSelectionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateFavoredOutcomeSelectionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisOutcomesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateAnalysisRequest} [commandsCreateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisPost(commandsCreateAnalysisRequest?: CommandsCreateAnalysisRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisPost(commandsCreateAnalysisRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsAnalysisDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProportionalAnalysesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsProportionalAnalyses2TableTypeNameDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProportionalAnalysesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProportionalAnalysesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateProportionalGroupSelectionsRequest} [commandsCreateProportionalGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest?: CommandsCreateProportionalGroupSelectionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProportionalGroupSelectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProportionalMeritVariablesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProportionalMeritVariablesAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProportionalStrataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProportionalStrataAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProportionalAnalysisSummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisProportionalSummaryAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateAnalysisRequest} [commandsUpdateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisPut(commandsUpdateAnalysisRequest?: CommandsUpdateAnalysisRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUpdateAnalysisResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisPut(commandsUpdateAnalysisRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetStrataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisStrataAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisStrataAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraAnalysisSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAnalysisRunBySummaryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraAnalysisSummaryAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AnalysisApi.apiSraAnalysisSummaryAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AnalysisApi - factory interface
 * @export
 */
export const AnalysisApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalysisApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisAnalysisTypesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsAnalysisTypeDTO>> {
            return localVarFp.apiSraAnalysisAnalysisTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisAvailableTablesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsBAIImportTables>> {
            return localVarFp.apiSraAnalysisAvailableTablesProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig): AxiosPromise<TransferObjectsInProgressDataDTO> {
            return localVarFp.apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID, analysisCategoryID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} calculateProgressID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateMeritVariablesRequest} [commandsCreateMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest?: CommandsCreateMeritVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateProportionalMeritVariablesRequest} [commandsCreateProportionalMeritVariablesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest?: CommandsCreateProportionalMeritVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateProportionalStrataRequest} [commandsCreateProportionalStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest?: CommandsCreateProportionalStrataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsCreateProportionalStrataResponse> {
            return localVarFp.apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateStrataRequest} [commandsCreateStrataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest?: CommandsCreateStrataRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsCreateStrataResponse> {
            return localVarFp.apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsDeleteAnalysisRequest} [commandsDeleteAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisDelete(commandsDeleteAnalysisRequest?: CommandsDeleteAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsDeleteAnalysisResponse> {
            return localVarFp.apiSraAnalysisDelete(commandsDeleteAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisDetailsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetAnalysisDetailsResponse> {
            return localVarFp.apiSraAnalysisDetailsAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [analysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupOptionsGet(analysisID?: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProportionalGroupOptionsResponse> {
            return localVarFp.apiSraAnalysisGroupOptionsGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetGroupSelectionsResponse> {
            return localVarFp.apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateGroupSelectionsRequest} [commandsCreateGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest?: CommandsCreateGroupSelectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} selectedFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID: string, selectedFieldGUID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID, selectedFieldGUID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisImportAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetImportDataResponse> {
            return localVarFp.apiSraAnalysisImportAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisImportAnalysisIDPost(analysisID: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<CommandsImportSetupResponse> {
            return localVarFp.apiSraAnalysisImportAnalysisIDPost(analysisID, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetMeritVariablesResponse> {
            return localVarFp.apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {string} analysisFieldGUID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID: string, analysisFieldGUID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsFavoredOutcomeValuesDTO>> {
            return localVarFp.apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID, analysisFieldGUID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetSelectionFieldsResponse> {
            return localVarFp.apiSraAnalysisOutcomesAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateFavoredOutcomeSelectionsRequest} [commandsCreateFavoredOutcomeSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest?: CommandsCreateFavoredOutcomeSelectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsCreateFavoredOutcomeSelectionsResponse> {
            return localVarFp.apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateAnalysisRequest} [commandsCreateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisPost(commandsCreateAnalysisRequest?: CommandsCreateAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsCreateAnalysisResponse> {
            return localVarFp.apiSraAnalysisPost(commandsCreateAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsAnalysisDTO>> {
            return localVarFp.apiSraAnalysisProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalAnalysesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsProportionalAnalyses2TableTypeNameDTO>> {
            return localVarFp.apiSraAnalysisProportionalAnalysesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateProportionalGroupSelectionsRequest} [commandsCreateProportionalGroupSelectionsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest?: CommandsCreateProportionalGroupSelectionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProportionalMeritVariablesResponse> {
            return localVarFp.apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProportionalStrataResponse> {
            return localVarFp.apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProportionalAnalysisSummaryResponse> {
            return localVarFp.apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateAnalysisRequest} [commandsUpdateAnalysisRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisPut(commandsUpdateAnalysisRequest?: CommandsUpdateAnalysisRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsUpdateAnalysisResponse> {
            return localVarFp.apiSraAnalysisPut(commandsUpdateAnalysisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetStrataResponse> {
            return localVarFp.apiSraAnalysisStrataAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraAnalysisSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetAnalysisRunBySummaryResponse> {
            return localVarFp.apiSraAnalysisSummaryAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalysisApi - object-oriented interface
 * @export
 * @class AnalysisApi
 * @extends {BaseAPI}
 */
export class AnalysisApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisAnalysisTypesGet(options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisAnalysisTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisAvailableTablesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisAvailableTablesProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {EnumerationsAnalysisCategory} analysisCategoryID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCalculateAnalysisIDAnalysisCategoryIDPost(analysisID, analysisCategoryID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} calculateProgressID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCalculateProgressIDCancelCalculationPost(calculateProgressID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateMeritVariablesRequest} [commandsCreateMeritVariablesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest?: CommandsCreateMeritVariablesRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCreateMeritVariablesPost(commandsCreateMeritVariablesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateProportionalMeritVariablesRequest} [commandsCreateProportionalMeritVariablesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest?: CommandsCreateProportionalMeritVariablesRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCreateProportionalMeritVariablesPost(commandsCreateProportionalMeritVariablesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateProportionalStrataRequest} [commandsCreateProportionalStrataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest?: CommandsCreateProportionalStrataRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCreateProportionalStrataPost(commandsCreateProportionalStrataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateStrataRequest} [commandsCreateStrataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest?: CommandsCreateStrataRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisCreateStrataPost(commandsCreateStrataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsDeleteAnalysisRequest} [commandsDeleteAnalysisRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisDelete(commandsDeleteAnalysisRequest?: CommandsDeleteAnalysisRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisDelete(commandsDeleteAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisDetailsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisDetailsAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [analysisID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisGroupOptionsGet(analysisID?: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisGroupOptionsGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisGroupSelectionsAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateGroupSelectionsRequest} [commandsCreateGroupSelectionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest?: CommandsCreateGroupSelectionsRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisGroupSelectionsPost(commandsCreateGroupSelectionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {string} selectedFieldGUID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID: string, selectedFieldGUID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisGroupSelectionsValuesAnalysisIDSelectedFieldGUIDGet(analysisID, selectedFieldGUID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisImportAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisImportAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisImportAnalysisIDPost(analysisID: string, file?: File, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisImportAnalysisIDPost(analysisID, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisMeritVariablesAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {string} analysisFieldGUID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID: string, analysisFieldGUID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisOutcomesAnalysisIDAnalysisFieldGUIDGet(analysisID, analysisFieldGUID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisOutcomesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisOutcomesAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateFavoredOutcomeSelectionsRequest} [commandsCreateFavoredOutcomeSelectionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest?: CommandsCreateFavoredOutcomeSelectionsRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisOutcomesPost(commandsCreateFavoredOutcomeSelectionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateAnalysisRequest} [commandsCreateAnalysisRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisPost(commandsCreateAnalysisRequest?: CommandsCreateAnalysisRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisPost(commandsCreateAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProportionalAnalysesGet(options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProportionalAnalysesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateProportionalGroupSelectionsRequest} [commandsCreateProportionalGroupSelectionsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest?: CommandsCreateProportionalGroupSelectionsRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProportionalGroupSelectionsPost(commandsCreateProportionalGroupSelectionsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProportionalMeritVariablesAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProportionalStrataAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisProportionalSummaryAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateAnalysisRequest} [commandsUpdateAnalysisRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisPut(commandsUpdateAnalysisRequest?: CommandsUpdateAnalysisRequest, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisPut(commandsUpdateAnalysisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisStrataAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisStrataAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalysisApi
     */
    public apiSraAnalysisSummaryAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return AnalysisApiFp(this.configuration).apiSraAnalysisSummaryAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DataVisualizationsApi - axios parameter creator
 * @export
 */
export const DataVisualizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {QueriesGetApplicantFlowDataVisualizationRequest} [queriesGetApplicantFlowDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsApplicantFlowPost: async (queriesGetApplicantFlowDataVisualizationRequest?: QueriesGetApplicantFlowDataVisualizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/applicant-flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetApplicantFlowDataVisualizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsFiltersAnalysisIDGet: async (analysisID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraDataVisualizationsFiltersAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/DataVisualizations/filters/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetLaborMarketRequest} [queriesGetLaborMarketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsLaborMarketPost: async (queriesGetLaborMarketRequest?: QueriesGetLaborMarketRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/labor-market`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetLaborMarketRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsOverviewFiltersProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraDataVisualizationsOverviewFiltersProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/DataVisualizations/overview-filters/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetOverviewRequest} [queriesGetOverviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsOverviewPost: async (queriesGetOverviewRequest?: QueriesGetOverviewRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetOverviewRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultSignificantResultsSummaryRequest} [queriesGetProportionalDefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalSignificantResultsSummaryPost: async (queriesGetProportionalDefaultSignificantResultsSummaryRequest?: QueriesGetProportionalDefaultSignificantResultsSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/proportional-significant-results-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetProportionalDefaultSignificantResultsSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultStatisticalValueSummaryRequest} [queriesGetProportionalDefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalStatisticalValueSummaryPost: async (queriesGetProportionalDefaultStatisticalValueSummaryRequest?: QueriesGetProportionalDefaultStatisticalValueSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/proportional-statistical-value-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetProportionalDefaultStatisticalValueSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetProportionalDataVisualizationRequest} [queriesGetProportionalDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalTileDataPost: async (queriesGetProportionalDataVisualizationRequest?: QueriesGetProportionalDataVisualizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/proportional-tile-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetProportionalDataVisualizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesRefreshTop10BiggestGapsTableRequest} [queriesRefreshTop10BiggestGapsTableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshBiggestGapPost: async (queriesRefreshTop10BiggestGapsTableRequest?: QueriesRefreshTop10BiggestGapsTableRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/refresh-biggest-gap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesRefreshTop10BiggestGapsTableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesRefreshTop10DispCodeForGroupRequest} [queriesRefreshTop10DispCodeForGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshDispcodeChartPost: async (queriesRefreshTop10DispCodeForGroupRequest?: QueriesRefreshTop10DispCodeForGroupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/refresh-dispcode-chart`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesRefreshTop10DispCodeForGroupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetProportionalSignificantResultsSummaryRequest} [queriesGetProportionalSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost: async (queriesGetProportionalSignificantResultsSummaryRequest?: QueriesGetProportionalSignificantResultsSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/refresh-proportional-significant-results-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetProportionalSignificantResultsSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetProportionalStatisticalValueSummaryRequest} [queriesGetProportionalStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost: async (analysisID: string, queriesGetProportionalStatisticalValueSummaryRequest?: QueriesGetProportionalStatisticalValueSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost', 'analysisID', analysisID)
            const localVarPath = `/api/sra/DataVisualizations/refresh-proportional-statistical-value-summary/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetProportionalStatisticalValueSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetSRASignificantResultsSummaryRequest} [queriesGetSRASignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshSignificantResultsSummaryPost: async (queriesGetSRASignificantResultsSummaryRequest?: QueriesGetSRASignificantResultsSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/refresh-significant-results-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetSRASignificantResultsSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetSRAStatisticalValueSummaryRequest} [queriesGetSRAStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost: async (analysisID: string, queriesGetSRAStatisticalValueSummaryRequest?: QueriesGetSRAStatisticalValueSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost', 'analysisID', analysisID)
            const localVarPath = `/api/sra/DataVisualizations/refresh-statistical-value-summary/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetSRAStatisticalValueSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetSRADefaultSignificantResultsSummaryRequest} [queriesGetSRADefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsSignificantResultsSummaryPost: async (queriesGetSRADefaultSignificantResultsSummaryRequest?: QueriesGetSRADefaultSignificantResultsSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/significant-results-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetSRADefaultSignificantResultsSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetSRADataVisualizationRequest} [queriesGetSRADataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsSraTileDataPost: async (queriesGetSRADataVisualizationRequest?: QueriesGetSRADataVisualizationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/sra-tile-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetSRADataVisualizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetSRADefaultStatisticalValueSummaryRequest} [queriesGetSRADefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsStatisticalValueSummaryPost: async (queriesGetSRADefaultStatisticalValueSummaryRequest?: QueriesGetSRADefaultStatisticalValueSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/statistical-value-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetSRADefaultStatisticalValueSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {QueriesGetWorkforceRepresentationRequest} [queriesGetWorkforceRepresentationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsWorkforceRepresentationPost: async (queriesGetWorkforceRepresentationRequest?: QueriesGetWorkforceRepresentationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/DataVisualizations/workforce-representation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(queriesGetWorkforceRepresentationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataVisualizationsApi - functional programming interface
 * @export
 */
export const DataVisualizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataVisualizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {QueriesGetApplicantFlowDataVisualizationRequest} [queriesGetApplicantFlowDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest?: QueriesGetApplicantFlowDataVisualizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetApplicantFlowDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsApplicantFlowPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAnalysisFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsFiltersAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetLaborMarketRequest} [queriesGetLaborMarketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest?: QueriesGetLaborMarketRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetLaborMarketResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsLaborMarketPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetAnalysisFiltersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsOverviewFiltersProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetOverviewRequest} [queriesGetOverviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest?: QueriesGetOverviewRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsOverviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultSignificantResultsSummaryRequest} [queriesGetProportionalDefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest?: QueriesGetProportionalDefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetDefaultSignificantResultsSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsProportionalSignificantResultsSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultStatisticalValueSummaryRequest} [queriesGetProportionalDefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest?: QueriesGetProportionalDefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetDefaultStatisticalValueSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsProportionalStatisticalValueSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetProportionalDataVisualizationRequest} [queriesGetProportionalDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest?: QueriesGetProportionalDataVisualizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProportionalDataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsProportionalTileDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesRefreshTop10BiggestGapsTableRequest} [queriesRefreshTop10BiggestGapsTableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest?: QueriesRefreshTop10BiggestGapsTableRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesTop10BiggestGapsTable>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshBiggestGapPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesRefreshTop10DispCodeForGroupRequest} [queriesRefreshTop10DispCodeForGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest?: QueriesRefreshTop10DispCodeForGroupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataVizDispCodeGroupChartData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshDispcodeChartPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetProportionalSignificantResultsSummaryRequest} [queriesGetProportionalSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest?: QueriesGetProportionalSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetSignificantResultsSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetProportionalStatisticalValueSummaryRequest} [queriesGetProportionalStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetProportionalStatisticalValueSummaryRequest?: QueriesGetProportionalStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetStatisticalValueSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetProportionalStatisticalValueSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetSRASignificantResultsSummaryRequest} [queriesGetSRASignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest?: QueriesGetSRASignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetSignificantResultsSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshSignificantResultsSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetSRAStatisticalValueSummaryRequest} [queriesGetSRAStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetSRAStatisticalValueSummaryRequest?: QueriesGetSRAStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetStatisticalValueSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetSRAStatisticalValueSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetSRADefaultSignificantResultsSummaryRequest} [queriesGetSRADefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest?: QueriesGetSRADefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetDefaultSignificantResultsSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsSignificantResultsSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetSRADataVisualizationRequest} [queriesGetSRADataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest?: QueriesGetSRADataVisualizationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetSRADataVisualizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsSraTileDataPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetSRADefaultStatisticalValueSummaryRequest} [queriesGetSRADefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest?: QueriesGetSRADefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataVizGetDefaultStatisticalValueSummaryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsStatisticalValueSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {QueriesGetWorkforceRepresentationRequest} [queriesGetWorkforceRepresentationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest?: QueriesGetWorkforceRepresentationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetWorkforceRepresentationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataVisualizationsApi.apiSraDataVisualizationsWorkforceRepresentationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataVisualizationsApi - factory interface
 * @export
 */
export const DataVisualizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataVisualizationsApiFp(configuration)
    return {
        /**
         * 
         * @param {QueriesGetApplicantFlowDataVisualizationRequest} [queriesGetApplicantFlowDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest?: QueriesGetApplicantFlowDataVisualizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetApplicantFlowDataVisualizationResponse> {
            return localVarFp.apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetAnalysisFiltersResponse> {
            return localVarFp.apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetLaborMarketRequest} [queriesGetLaborMarketRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest?: QueriesGetLaborMarketRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetLaborMarketResponse> {
            return localVarFp.apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetAnalysisFiltersResponse> {
            return localVarFp.apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetOverviewRequest} [queriesGetOverviewRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest?: QueriesGetOverviewRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetOverviewResponse> {
            return localVarFp.apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultSignificantResultsSummaryRequest} [queriesGetProportionalDefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest?: QueriesGetProportionalDefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetDefaultSignificantResultsSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetProportionalDefaultStatisticalValueSummaryRequest} [queriesGetProportionalDefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest?: QueriesGetProportionalDefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetDefaultStatisticalValueSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetProportionalDataVisualizationRequest} [queriesGetProportionalDataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest?: QueriesGetProportionalDataVisualizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProportionalDataVisualizationResponse> {
            return localVarFp.apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesRefreshTop10BiggestGapsTableRequest} [queriesRefreshTop10BiggestGapsTableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest?: QueriesRefreshTop10BiggestGapsTableRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesTop10BiggestGapsTable> {
            return localVarFp.apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesRefreshTop10DispCodeForGroupRequest} [queriesRefreshTop10DispCodeForGroupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest?: QueriesRefreshTop10DispCodeForGroupRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<DataVizDispCodeGroupChartData>> {
            return localVarFp.apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetProportionalSignificantResultsSummaryRequest} [queriesGetProportionalSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest?: QueriesGetProportionalSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetSignificantResultsSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetProportionalStatisticalValueSummaryRequest} [queriesGetProportionalStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetProportionalStatisticalValueSummaryRequest?: QueriesGetProportionalStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetStatisticalValueSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetProportionalStatisticalValueSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetSRASignificantResultsSummaryRequest} [queriesGetSRASignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest?: QueriesGetSRASignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetSignificantResultsSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {QueriesGetSRAStatisticalValueSummaryRequest} [queriesGetSRAStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetSRAStatisticalValueSummaryRequest?: QueriesGetSRAStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetStatisticalValueSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetSRAStatisticalValueSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetSRADefaultSignificantResultsSummaryRequest} [queriesGetSRADefaultSignificantResultsSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest?: QueriesGetSRADefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetDefaultSignificantResultsSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetSRADataVisualizationRequest} [queriesGetSRADataVisualizationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest?: QueriesGetSRADataVisualizationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetSRADataVisualizationResponse> {
            return localVarFp.apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetSRADefaultStatisticalValueSummaryRequest} [queriesGetSRADefaultStatisticalValueSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest?: QueriesGetSRADefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataVizGetDefaultStatisticalValueSummaryDTO> {
            return localVarFp.apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {QueriesGetWorkforceRepresentationRequest} [queriesGetWorkforceRepresentationRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest?: QueriesGetWorkforceRepresentationRequest, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetWorkforceRepresentationResponse> {
            return localVarFp.apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataVisualizationsApi - object-oriented interface
 * @export
 * @class DataVisualizationsApi
 * @extends {BaseAPI}
 */
export class DataVisualizationsApi extends BaseAPI {
    /**
     * 
     * @param {QueriesGetApplicantFlowDataVisualizationRequest} [queriesGetApplicantFlowDataVisualizationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest?: QueriesGetApplicantFlowDataVisualizationRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsApplicantFlowPost(queriesGetApplicantFlowDataVisualizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsFiltersAnalysisIDGet(analysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetLaborMarketRequest} [queriesGetLaborMarketRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest?: QueriesGetLaborMarketRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsLaborMarketPost(queriesGetLaborMarketRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsOverviewFiltersProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetOverviewRequest} [queriesGetOverviewRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest?: QueriesGetOverviewRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsOverviewPost(queriesGetOverviewRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetProportionalDefaultSignificantResultsSummaryRequest} [queriesGetProportionalDefaultSignificantResultsSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest?: QueriesGetProportionalDefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsProportionalSignificantResultsSummaryPost(queriesGetProportionalDefaultSignificantResultsSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetProportionalDefaultStatisticalValueSummaryRequest} [queriesGetProportionalDefaultStatisticalValueSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest?: QueriesGetProportionalDefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsProportionalStatisticalValueSummaryPost(queriesGetProportionalDefaultStatisticalValueSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetProportionalDataVisualizationRequest} [queriesGetProportionalDataVisualizationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest?: QueriesGetProportionalDataVisualizationRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsProportionalTileDataPost(queriesGetProportionalDataVisualizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesRefreshTop10BiggestGapsTableRequest} [queriesRefreshTop10BiggestGapsTableRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest?: QueriesRefreshTop10BiggestGapsTableRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshBiggestGapPost(queriesRefreshTop10BiggestGapsTableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesRefreshTop10DispCodeForGroupRequest} [queriesRefreshTop10DispCodeForGroupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest?: QueriesRefreshTop10DispCodeForGroupRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshDispcodeChartPost(queriesRefreshTop10DispCodeForGroupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetProportionalSignificantResultsSummaryRequest} [queriesGetProportionalSignificantResultsSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest?: QueriesGetProportionalSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshProportionalSignificantResultsSummaryPost(queriesGetProportionalSignificantResultsSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {QueriesGetProportionalStatisticalValueSummaryRequest} [queriesGetProportionalStatisticalValueSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetProportionalStatisticalValueSummaryRequest?: QueriesGetProportionalStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshProportionalStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetProportionalStatisticalValueSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetSRASignificantResultsSummaryRequest} [queriesGetSRASignificantResultsSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest?: QueriesGetSRASignificantResultsSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshSignificantResultsSummaryPost(queriesGetSRASignificantResultsSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {QueriesGetSRAStatisticalValueSummaryRequest} [queriesGetSRAStatisticalValueSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID: string, queriesGetSRAStatisticalValueSummaryRequest?: QueriesGetSRAStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsRefreshStatisticalValueSummaryAnalysisIDPost(analysisID, queriesGetSRAStatisticalValueSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetSRADefaultSignificantResultsSummaryRequest} [queriesGetSRADefaultSignificantResultsSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest?: QueriesGetSRADefaultSignificantResultsSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsSignificantResultsSummaryPost(queriesGetSRADefaultSignificantResultsSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetSRADataVisualizationRequest} [queriesGetSRADataVisualizationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest?: QueriesGetSRADataVisualizationRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsSraTileDataPost(queriesGetSRADataVisualizationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetSRADefaultStatisticalValueSummaryRequest} [queriesGetSRADefaultStatisticalValueSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest?: QueriesGetSRADefaultStatisticalValueSummaryRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsStatisticalValueSummaryPost(queriesGetSRADefaultStatisticalValueSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {QueriesGetWorkforceRepresentationRequest} [queriesGetWorkforceRepresentationRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataVisualizationsApi
     */
    public apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest?: QueriesGetWorkforceRepresentationRequest, options?: RawAxiosRequestConfig) {
        return DataVisualizationsApiFp(this.configuration).apiSraDataVisualizationsWorkforceRepresentationPost(queriesGetWorkforceRepresentationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApi - axios parameter creator
 * @export
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} baiPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectAvailableTablesBaiPlanIDGet: async (baiPlanID: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'baiPlanID' is not null or undefined
            assertParamExists('apiSraProjectAvailableTablesBaiPlanIDGet', 'baiPlanID', baiPlanID)
            const localVarPath = `/api/sra/Project/available-tables/{baiPlanID}`
                .replace(`{${"baiPlanID"}}`, encodeURIComponent(String(baiPlanID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsDeleteProjectRequest} [commandsDeleteProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectDelete: async (commandsDeleteProjectRequest?: CommandsDeleteProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsDeleteProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsSendProjectSharedEmailsRequest} [commandsSendProjectSharedEmailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectEmailUsersPost: async (commandsSendProjectSharedEmailsRequest?: CommandsSendProjectSharedEmailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/email-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsSendProjectSharedEmailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsGrantUserAccessToProjectRequest} [commandsGrantUserAccessToProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectGrantUserAccessPost: async (commandsGrantUserAccessToProjectRequest?: CommandsGrantUserAccessToProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/grant-user-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsGrantUserAccessToProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsImportFromBAISetupRequest} [commandsImportFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectImportAapPost: async (commandsImportFromBAISetupRequest?: CommandsImportFromBAISetupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/import-aap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsImportFromBAISetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {EnumerationsComplianceType} complianceTypeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectImportAapProjectIDComplianceTypeIDGet: async (projectID: string, complianceTypeID: EnumerationsComplianceType, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraProjectImportAapProjectIDComplianceTypeIDGet', 'projectID', projectID)
            // verify required parameter 'complianceTypeID' is not null or undefined
            assertParamExists('apiSraProjectImportAapProjectIDComplianceTypeIDGet', 'complianceTypeID', complianceTypeID)
            const localVarPath = `/api/sra/Project/import-aap/{projectID}/{complianceTypeID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)))
                .replace(`{${"complianceTypeID"}}`, encodeURIComponent(String(complianceTypeID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectPost: async (commandsCreateProjectRequest?: CommandsCreateProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectProjectAnalysesProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraProjectProjectAnalysesProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Project/project-analyses/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectProjectIDSharingGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraProjectProjectIDSharingGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Project/{projectID}/sharing`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectPut: async (commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsReImportAvailabilityDataFromBAISetupRequest} [commandsReImportAvailabilityDataFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectReimportAvailabilityPost: async (commandsReImportAvailabilityDataFromBAISetupRequest?: CommandsReImportAvailabilityDataFromBAISetupRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/reimport-availability`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsReImportAvailabilityDataFromBAISetupRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsRemoveUserAccessFromProjectRequest} [commandsRemoveUserAccessFromProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectRemoveUserAccessPost: async (commandsRemoveUserAccessFromProjectRequest?: CommandsRemoveUserAccessFromProjectRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/remove-user-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsRemoveUserAccessFromProjectRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSelectorGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/selector`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSelectorProjectIDPost: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraProjectSelectorProjectIDPost', 'projectID', projectID)
            const localVarPath = `/api/sra/Project/selector/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateProjectSharingRequest} [commandsUpdateProjectSharingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSharingStatusPut: async (commandsUpdateProjectSharingRequest?: CommandsUpdateProjectSharingRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Project/sharing-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateProjectSharingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 * @export
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} baiPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModelsBAIImportTables>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectAvailableTablesBaiPlanIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsDeleteProjectRequest} [commandsDeleteProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectDelete(commandsDeleteProjectRequest?: CommandsDeleteProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsDeleteProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectDelete(commandsDeleteProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsSendProjectSharedEmailsRequest} [commandsSendProjectSharedEmailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest?: CommandsSendProjectSharedEmailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsSendProjectSharedEmailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectEmailUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsManageProjectsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsGrantUserAccessToProjectRequest} [commandsGrantUserAccessToProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest?: CommandsGrantUserAccessToProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsGrantUserAccessToProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectGrantUserAccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsImportFromBAISetupRequest} [commandsImportFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectImportAapPost(commandsImportFromBAISetupRequest?: CommandsImportFromBAISetupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsImportSetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectImportAapPost(commandsImportFromBAISetupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectImportAapPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {EnumerationsComplianceType} complianceTypeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID: string, complianceTypeID: EnumerationsComplianceType, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetBAIImportDataResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID, complianceTypeID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectImportAapProjectIDComplianceTypeIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsCreateProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectPost(commandsCreateProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectProjectAnalysesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProjectAnalysesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectProjectAnalysesProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectProjectAnalysesProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectProjectIDSharingGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProjectSharingDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectProjectIDSharingGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectProjectIDSharingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectPut(commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUpdateProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectPut(commandsUpdateProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsReImportAvailabilityDataFromBAISetupRequest} [commandsReImportAvailabilityDataFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest?: CommandsReImportAvailabilityDataFromBAISetupRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsReImportAvailabilityDataFromBAISetupResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectReimportAvailabilityPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsRemoveUserAccessFromProjectRequest} [commandsRemoveUserAccessFromProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest?: CommandsRemoveUserAccessFromProjectRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsRemoveUserAccessFromProjectResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectRemoveUserAccessPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectSelectorGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetProjectSelectorResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectSelectorGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectSelectorGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectSelectorProjectIDPost(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectSelectorProjectIDPost(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectSelectorProjectIDPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateProjectSharingRequest} [commandsUpdateProjectSharingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest?: CommandsUpdateProjectSharingRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommandsUpdateProjectSharingResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.apiSraProjectSharingStatusPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApi - factory interface
 * @export
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApiFp(configuration)
    return {
        /**
         * 
         * @param {number} baiPlanID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ModelsBAIImportTables>> {
            return localVarFp.apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsDeleteProjectRequest} [commandsDeleteProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectDelete(commandsDeleteProjectRequest?: CommandsDeleteProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsDeleteProjectResponse> {
            return localVarFp.apiSraProjectDelete(commandsDeleteProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsSendProjectSharedEmailsRequest} [commandsSendProjectSharedEmailsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest?: CommandsSendProjectSharedEmailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsSendProjectSharedEmailsResponse> {
            return localVarFp.apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsManageProjectsDTO>> {
            return localVarFp.apiSraProjectGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsGrantUserAccessToProjectRequest} [commandsGrantUserAccessToProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest?: CommandsGrantUserAccessToProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsGrantUserAccessToProjectResponse> {
            return localVarFp.apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsImportFromBAISetupRequest} [commandsImportFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectImportAapPost(commandsImportFromBAISetupRequest?: CommandsImportFromBAISetupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsImportSetupResponse> {
            return localVarFp.apiSraProjectImportAapPost(commandsImportFromBAISetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {EnumerationsComplianceType} complianceTypeID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID: string, complianceTypeID: EnumerationsComplianceType, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetBAIImportDataResponse> {
            return localVarFp.apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID, complianceTypeID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsCreateProjectResponse> {
            return localVarFp.apiSraProjectPost(commandsCreateProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectProjectAnalysesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProjectAnalysesResponse> {
            return localVarFp.apiSraProjectProjectAnalysesProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectProjectIDSharingGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProjectSharingDetailsResponse> {
            return localVarFp.apiSraProjectProjectIDSharingGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectPut(commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsUpdateProjectResponse> {
            return localVarFp.apiSraProjectPut(commandsUpdateProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsReImportAvailabilityDataFromBAISetupRequest} [commandsReImportAvailabilityDataFromBAISetupRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest?: CommandsReImportAvailabilityDataFromBAISetupRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsReImportAvailabilityDataFromBAISetupResponse> {
            return localVarFp.apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsRemoveUserAccessFromProjectRequest} [commandsRemoveUserAccessFromProjectRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest?: CommandsRemoveUserAccessFromProjectRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsRemoveUserAccessFromProjectResponse> {
            return localVarFp.apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSelectorGet(options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetProjectSelectorResponse> {
            return localVarFp.apiSraProjectSelectorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSelectorProjectIDPost(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraProjectSelectorProjectIDPost(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateProjectSharingRequest} [commandsUpdateProjectSharingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest?: CommandsUpdateProjectSharingRequest, options?: RawAxiosRequestConfig): AxiosPromise<CommandsUpdateProjectSharingResponse> {
            return localVarFp.apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApi - object-oriented interface
 * @export
 * @class ProjectApi
 * @extends {BaseAPI}
 */
export class ProjectApi extends BaseAPI {
    /**
     * 
     * @param {number} baiPlanID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectAvailableTablesBaiPlanIDGet(baiPlanID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsDeleteProjectRequest} [commandsDeleteProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectDelete(commandsDeleteProjectRequest?: CommandsDeleteProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectDelete(commandsDeleteProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsSendProjectSharedEmailsRequest} [commandsSendProjectSharedEmailsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest?: CommandsSendProjectSharedEmailsRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectEmailUsersPost(commandsSendProjectSharedEmailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectGet(options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsGrantUserAccessToProjectRequest} [commandsGrantUserAccessToProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest?: CommandsGrantUserAccessToProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectGrantUserAccessPost(commandsGrantUserAccessToProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsImportFromBAISetupRequest} [commandsImportFromBAISetupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectImportAapPost(commandsImportFromBAISetupRequest?: CommandsImportFromBAISetupRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectImportAapPost(commandsImportFromBAISetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {EnumerationsComplianceType} complianceTypeID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID: string, complianceTypeID: EnumerationsComplianceType, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectImportAapProjectIDComplianceTypeIDGet(projectID, complianceTypeID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateProjectRequest} [commandsCreateProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectPost(commandsCreateProjectRequest?: CommandsCreateProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectPost(commandsCreateProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectProjectAnalysesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectProjectAnalysesProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectProjectIDSharingGet(projectID: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectProjectIDSharingGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateProjectRequest} [commandsUpdateProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectPut(commandsUpdateProjectRequest?: CommandsUpdateProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectPut(commandsUpdateProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsReImportAvailabilityDataFromBAISetupRequest} [commandsReImportAvailabilityDataFromBAISetupRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest?: CommandsReImportAvailabilityDataFromBAISetupRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectReimportAvailabilityPost(commandsReImportAvailabilityDataFromBAISetupRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsRemoveUserAccessFromProjectRequest} [commandsRemoveUserAccessFromProjectRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest?: CommandsRemoveUserAccessFromProjectRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectRemoveUserAccessPost(commandsRemoveUserAccessFromProjectRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectSelectorGet(options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectSelectorGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectSelectorProjectIDPost(projectID: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectSelectorProjectIDPost(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateProjectSharingRequest} [commandsUpdateProjectSharingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectApi
     */
    public apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest?: CommandsUpdateProjectSharingRequest, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).apiSraProjectSharingStatusPut(commandsUpdateProjectSharingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsNotificationIDCancelExportPost: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiSraReportsNotificationIDCancelExportPost', 'notificationID', notificationID)
            const localVarPath = `/api/sra/Reports/{notificationID}/cancel-export`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsNotificationIDDownloadGet: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiSraReportsNotificationIDDownloadGet', 'notificationID', notificationID)
            const localVarPath = `/api/sra/Reports/{notificationID}/download`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {Array<TransferObjectsReportExportDTO>} [transferObjectsReportExportDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsProjectIDExportPost: async (projectID: string, transferObjectsReportExportDTO?: Array<TransferObjectsReportExportDTO>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraReportsProjectIDExportPost', 'projectID', projectID)
            const localVarPath = `/api/sra/Reports/{projectID}/export`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferObjectsReportExportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraReportsProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Reports/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet: async (analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet', 'analysisID', analysisID)
            // verify required parameter 'analysisCategoryID' is not null or undefined
            assertParamExists('apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet', 'analysisCategoryID', analysisCategoryID)
            const localVarPath = `/api/sra/Reports/settings/{analysisID}/{analysisCategoryID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)))
                .replace(`{${"analysisCategoryID"}}`, encodeURIComponent(String(analysisCategoryID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsRequest} [commandsUpdateReportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsSettingsPut: async (commandsUpdateReportSettingsRequest?: CommandsUpdateReportSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Reports/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateReportSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsNotificationIDCancelExportPost(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsNotificationIDCancelExportPost(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsNotificationIDCancelExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsNotificationIDDownloadGet(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsNotificationIDDownloadGet(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsNotificationIDDownloadGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {Array<TransferObjectsReportExportDTO>} [transferObjectsReportExportDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsProjectIDExportPost(projectID: string, transferObjectsReportExportDTO?: Array<TransferObjectsReportExportDTO>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsProjectIDExportPost(projectID, transferObjectsReportExportDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsProjectIDExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsReportsDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetReportSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID, analysisCategoryID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsRequest} [commandsUpdateReportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest?: CommandsUpdateReportSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiSraReportsSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsNotificationIDCancelExportPost(notificationID: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraReportsNotificationIDCancelExportPost(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsNotificationIDDownloadGet(notificationID: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraReportsNotificationIDDownloadGet(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {Array<TransferObjectsReportExportDTO>} [transferObjectsReportExportDTO] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsProjectIDExportPost(projectID: string, transferObjectsReportExportDTO?: Array<TransferObjectsReportExportDTO>, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSraReportsProjectIDExportPost(projectID, transferObjectsReportExportDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsReportsDTO>> {
            return localVarFp.apiSraReportsProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsAnalysisCategory} analysisCategoryID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetReportSettingsResponse> {
            return localVarFp.apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID, analysisCategoryID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateReportSettingsRequest} [commandsUpdateReportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest?: CommandsUpdateReportSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI {
    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsNotificationIDCancelExportPost(notificationID: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsNotificationIDCancelExportPost(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsNotificationIDDownloadGet(notificationID: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsNotificationIDDownloadGet(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {Array<TransferObjectsReportExportDTO>} [transferObjectsReportExportDTO] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsProjectIDExportPost(projectID: string, transferObjectsReportExportDTO?: Array<TransferObjectsReportExportDTO>, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsProjectIDExportPost(projectID, transferObjectsReportExportDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {EnumerationsAnalysisCategory} analysisCategoryID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID: string, analysisCategoryID: EnumerationsAnalysisCategory, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsSettingsAnalysisIDAnalysisCategoryIDGet(analysisID, analysisCategoryID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateReportSettingsRequest} [commandsUpdateReportSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest?: CommandsUpdateReportSettingsRequest, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiSraReportsSettingsPut(commandsUpdateReportSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SummariesApi - axios parameter creator
 * @export
 */
export const SummariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadNotificationIDGet: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiSraSummariesExecutiveSummaryDownloadNotificationIDGet', 'notificationID', notificationID)
            const localVarPath = `/api/sra/Summaries/executive-summary-download/{notificationID}`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet', 'notificationID', notificationID)
            const localVarPath = `/api/sra/Summaries/executive-summary-download-report/{notificationID}`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet: async (notificationID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationID' is not null or undefined
            assertParamExists('apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet', 'notificationID', notificationID)
            const localVarPath = `/api/sra/Summaries/executive-summary-download-zip/{notificationID}`
                .replace(`{${"notificationID"}}`, encodeURIComponent(String(notificationID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsGenerateExecutiveSummaryRequest} [commandsGenerateExecutiveSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryPost: async (commandsGenerateExecutiveSummaryRequest?: CommandsGenerateExecutiveSummaryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Summaries/executive-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsGenerateExecutiveSummaryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsCreateExecutiveSummarySettingsRequest} [commandsCreateExecutiveSummarySettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummarySettingsPost: async (commandsCreateExecutiveSummarySettingsRequest?: CommandsCreateExecutiveSummarySettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Summaries/executive-summary-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsCreateExecutiveSummarySettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummarySettingsProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraSummariesExecutiveSummarySettingsProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Summaries/executive-summary-settings/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TransferObjectsExportSummariesRequest} [transferObjectsExportSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExportPost: async (transferObjectsExportSummariesRequest?: TransferObjectsExportSummariesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Summaries/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferObjectsExportSummariesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesProjectIDGet: async (projectID: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectID' is not null or undefined
            assertParamExists('apiSraSummariesProjectIDGet', 'projectID', projectID)
            const localVarPath = `/api/sra/Summaries/{projectID}`
                .replace(`{${"projectID"}}`, encodeURIComponent(String(projectID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsProportionalAnalyses} [proportionalAnalysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesSettingsAnalysisIDGet: async (analysisID: string, proportionalAnalysisID?: EnumerationsProportionalAnalyses, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'analysisID' is not null or undefined
            assertParamExists('apiSraSummariesSettingsAnalysisIDGet', 'analysisID', analysisID)
            const localVarPath = `/api/sra/Summaries/settings/{analysisID}`
                .replace(`{${"analysisID"}}`, encodeURIComponent(String(analysisID)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (proportionalAnalysisID !== undefined) {
                localVarQueryParameter['proportionalAnalysisID'] = proportionalAnalysisID;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CommandsUpdateSummariesExportSettingsRequest} [commandsUpdateSummariesExportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesSettingsPut: async (commandsUpdateSummariesExportSettingsRequest?: CommandsUpdateSummariesExportSettingsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sra/Summaries/settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commandsUpdateSummariesExportSettingsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SummariesApi - functional programming interface
 * @export
 */
export const SummariesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SummariesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummaryDownloadNotificationIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsGenerateExecutiveSummaryRequest} [commandsGenerateExecutiveSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest?: CommandsGenerateExecutiveSummaryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummaryPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsCreateExecutiveSummarySettingsRequest} [commandsCreateExecutiveSummarySettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest?: CommandsCreateExecutiveSummarySettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummarySettingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QueriesGetExecutiveSummarySettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExecutiveSummarySettingsProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TransferObjectsExportSummariesRequest} [transferObjectsExportSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesExportPost(transferObjectsExportSummariesRequest?: TransferObjectsExportSummariesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesExportPost(transferObjectsExportSummariesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesExportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsSummariesDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesProjectIDGet(projectID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesProjectIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsProportionalAnalyses} [proportionalAnalysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesSettingsAnalysisIDGet(analysisID: string, proportionalAnalysisID?: EnumerationsProportionalAnalyses, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QueriesGetSummariesExportSettingsResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesSettingsAnalysisIDGet(analysisID, proportionalAnalysisID, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesSettingsAnalysisIDGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CommandsUpdateSummariesExportSettingsRequest} [commandsUpdateSummariesExportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest?: CommandsUpdateSummariesExportSettingsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SummariesApi.apiSraSummariesSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SummariesApi - factory interface
 * @export
 */
export const SummariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SummariesApiFp(configuration)
    return {
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} notificationID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsGenerateExecutiveSummaryRequest} [commandsGenerateExecutiveSummaryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest?: CommandsGenerateExecutiveSummaryRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsCreateExecutiveSummarySettingsRequest} [commandsCreateExecutiveSummarySettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest?: CommandsCreateExecutiveSummarySettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<QueriesGetExecutiveSummarySettingsResponse> {
            return localVarFp.apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TransferObjectsExportSummariesRequest} [transferObjectsExportSummariesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesExportPost(transferObjectsExportSummariesRequest?: TransferObjectsExportSummariesRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.apiSraSummariesExportPost(transferObjectsExportSummariesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} projectID 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsSummariesDTO>> {
            return localVarFp.apiSraSummariesProjectIDGet(projectID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} analysisID 
         * @param {EnumerationsProportionalAnalyses} [proportionalAnalysisID] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesSettingsAnalysisIDGet(analysisID: string, proportionalAnalysisID?: EnumerationsProportionalAnalyses, options?: RawAxiosRequestConfig): AxiosPromise<Array<QueriesGetSummariesExportSettingsResponse>> {
            return localVarFp.apiSraSummariesSettingsAnalysisIDGet(analysisID, proportionalAnalysisID, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CommandsUpdateSummariesExportSettingsRequest} [commandsUpdateSummariesExportSettingsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest?: CommandsUpdateSummariesExportSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SummariesApi - object-oriented interface
 * @export
 * @class SummariesApi
 * @extends {BaseAPI}
 */
export class SummariesApi extends BaseAPI {
    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummaryDownloadNotificationIDGet(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummaryDownloadReportNotificationIDGet(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} notificationID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID: string, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummaryDownloadZipNotificationIDGet(notificationID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsGenerateExecutiveSummaryRequest} [commandsGenerateExecutiveSummaryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest?: CommandsGenerateExecutiveSummaryRequest, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummaryPost(commandsGenerateExecutiveSummaryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsCreateExecutiveSummarySettingsRequest} [commandsCreateExecutiveSummarySettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest?: CommandsCreateExecutiveSummarySettingsRequest, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummarySettingsPost(commandsCreateExecutiveSummarySettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExecutiveSummarySettingsProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TransferObjectsExportSummariesRequest} [transferObjectsExportSummariesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesExportPost(transferObjectsExportSummariesRequest?: TransferObjectsExportSummariesRequest, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesExportPost(transferObjectsExportSummariesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} projectID 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesProjectIDGet(projectID: string, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesProjectIDGet(projectID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} analysisID 
     * @param {EnumerationsProportionalAnalyses} [proportionalAnalysisID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesSettingsAnalysisIDGet(analysisID: string, proportionalAnalysisID?: EnumerationsProportionalAnalyses, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesSettingsAnalysisIDGet(analysisID, proportionalAnalysisID, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CommandsUpdateSummariesExportSettingsRequest} [commandsUpdateSummariesExportSettingsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SummariesApi
     */
    public apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest?: CommandsUpdateSummariesExportSettingsRequest, options?: RawAxiosRequestConfig) {
        return SummariesApiFp(this.configuration).apiSraSummariesSettingsPut(commandsUpdateSummariesExportSettingsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EnumerationsProjectAccessSortColumn} sortColumn 
         * @param {EnumerationsSortDirection} sortDirection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraUsersProjectAccessSortColumnSortDirectionGet: async (sortColumn: EnumerationsProjectAccessSortColumn, sortDirection: EnumerationsSortDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortColumn' is not null or undefined
            assertParamExists('apiSraUsersProjectAccessSortColumnSortDirectionGet', 'sortColumn', sortColumn)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('apiSraUsersProjectAccessSortColumnSortDirectionGet', 'sortDirection', sortDirection)
            const localVarPath = `/api/sra/Users/project-access/{sortColumn}/{sortDirection}`
                .replace(`{${"sortColumn"}}`, encodeURIComponent(String(sortColumn)))
                .replace(`{${"sortDirection"}}`, encodeURIComponent(String(sortDirection)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EnumerationsProjectAccessSortColumn} sortColumn 
         * @param {EnumerationsSortDirection} sortDirection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn: EnumerationsProjectAccessSortColumn, sortDirection: EnumerationsSortDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransferObjectsProjectAccessDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn, sortDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.apiSraUsersProjectAccessSortColumnSortDirectionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @param {EnumerationsProjectAccessSortColumn} sortColumn 
         * @param {EnumerationsSortDirection} sortDirection 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn: EnumerationsProjectAccessSortColumn, sortDirection: EnumerationsSortDirection, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransferObjectsProjectAccessDTO>> {
            return localVarFp.apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn, sortDirection, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {EnumerationsProjectAccessSortColumn} sortColumn 
     * @param {EnumerationsSortDirection} sortDirection 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn: EnumerationsProjectAccessSortColumn, sortDirection: EnumerationsSortDirection, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).apiSraUsersProjectAccessSortColumnSortDirectionGet(sortColumn, sortDirection, options).then((request) => request(this.axios, this.basePath));
    }
}



